/* Kamerfoto's blijven lokaal totdat een aangesloten generator expliciet wordt gestart. */
(function (global) {
  "use strict";
  var MAX_FILE = 15 * 1024 * 1024;
  var TYPES = ["image/jpeg", "image/png", "image/webp"];

  function fotoFout(file) {
    if (!file) return "Kies eerst een foto van je ruimte.";
    if (TYPES.indexOf(file.type) < 0) return "Kies een JPG-, PNG- of WebP-foto. Zet een HEIC-foto eerst om naar JPG.";
    if (!file.size) return "Dit bestand is leeg. Kies een andere foto.";
    if (file.size > MAX_FILE) return "Deze foto is groter dan 15 MB. Kies een kleinere foto.";
    return "";
  }

  /* Kamerbreed tapijt (strekkende meter) vervangt de hele vloer; een kleed ligt erop. */
  function isTapijt(k) { return !!k && k.soort === "kamerbreed"; }

  function keuzeTekst(k) {
    if (!k) return "";
    if (isTapijt(k)) return [k.kleur, "Kamerbreed tapijt, van wand tot wand"].join(" · ");
    var cm = function (n) { return Number(n).toLocaleString("nl-NL", { maximumFractionDigits: 2 }); };
    // Kleed in standaardmaat (snippets/vm-kleed-ruimte.liquid): geen rand- of anti-slipkeuze.
    if (k.standaardmaat) return [k.kleur, k.vormNaam || k.vorm,
      k.vorm === "rond" ? "Ø " + cm(k.breedte) + " cm" : cm(k.breedte) + " × " + cm(k.lengte) + " cm"].join(" · ");
    return [k.kleur, k.vormNaam || k.vorm, cm(k.breedte) + " × " + cm(k.lengte) + " cm",
      k.afwerking + (k.randbreedte ? " · " + cm(k.randbreedte) + " cm" : ""),
      k.antislip ? "Met anti-slip" : "Zonder anti-slip"].join(" · ");
  }

  function zelfdeKeuze(a, b) { return JSON.stringify(a) === JSON.stringify(b); }

  /* Meting (Mastermind → Marketing → Vloerkleed foto impressies): onthoud per product dat de
     klant een impressie terugkreeg, zodat de configurator de maatwerkregel `_fotovoorbeeld`
     meegeeft. Alleen de producthandle en een tijd, alleen in deze browser, 30 dagen. */
  var IMPRESSIE_KEY = "vm-fotovoorbeeld", IMPRESSIE_MS = 30 * 864e5;
  function impressies() {
    try { var m = JSON.parse(localStorage.getItem(IMPRESSIE_KEY) || "{}"); return m && typeof m === "object" ? m : {}; }
    catch (e) { return {}; }
  }
  function noteerImpressie(handle) {
    if (!handle) return;
    try {
      var m = impressies(), grens = Date.now() - IMPRESSIE_MS;
      Object.keys(m).forEach(function (h) { if (!(m[h] > grens)) delete m[h]; });
      m[handle] = Date.now();
      localStorage.setItem(IMPRESSIE_KEY, JSON.stringify(m));
    } catch (e) {}
  }
  function hadImpressie(handle) {
    var t = handle ? impressies()[handle] : 0;
    return typeof t === "number" && t > Date.now() - IMPRESSIE_MS;
  }

  function veiligeResultaatData(value) {
    return typeof value === "string" && value.length <= 16000000 &&
      /^data:image\/(?:png|jpeg|webp);base64,[A-Za-z0-9+/]+={0,2}$/.test(value);
  }

  function generator(endpoint) {
    var url = new URL(endpoint);
    if (url.protocol !== "https:" || url.username || url.password || url.port || !/^(?:[a-z0-9-]+-)?vm-keuzehulp-proxy\.faruk-01b\.workers\.dev$/.test(url.hostname) || url.pathname !== "/api/vloerkleed/visualiseer") {
      throw new Error("Ongeldige fotokoppeling");
    }
    var sid;
    try {
      sid = localStorage.getItem("vm-ruimte-sid");
      if (!/^[0-9a-f-]{36}$/.test(sid || "")) { sid = crypto.randomUUID(); localStorage.setItem("vm-ruimte-sid", sid); }
    } catch (e) { sid = crypto.randomUUID(); }
    // Bewaar bij netwerkproblemen hetzelfde verzoek-id voor dezelfde invoer.
    // Een herhaalde klik kan zo niet nogmaals een betaalde generatie starten.
    var lastPhoto = "", lastChoice = "", requestId = "";
    return async function (input) {
      var fingerprint = JSON.stringify(input.choice);
      if (lastPhoto !== input.photo || lastChoice !== fingerprint) {
        requestId = crypto.randomUUID(); lastPhoto = input.photo; lastChoice = fingerprint;
      }
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 115000);
      try {
        var response = await fetch(url.href, {
          method: "POST", headers: { "Content-Type": "application/json" }, credentials: "omit",
          body: JSON.stringify({ sid: sid, requestId: requestId, photo: input.photo, choice: input.choice }),
          signal: controller.signal
        });
        if (!response.ok) throw new Error("Het fotovoorbeeld is tijdelijk niet beschikbaar. Probeer het later opnieuw.");
        var result = await response.json();
        if (!result || result.ok !== true) {
          // Een expliciete weigering van de beeldservice heeft geen generatie gestart.
          // Een bewuste nieuwe poging mag later een nieuw verzoek-id gebruiken.
          if (result && result.code === "PROVIDER_LIMIT") lastPhoto = lastChoice = "";
          var messages = {
            PROVIDER_LIMIT: "De beeldservice heeft momenteel geen ruimte voor een nieuw fotovoorbeeld. Probeer het later opnieuw.",
            DAILY_LIMIT: "Alle fotovoorbeelden voor vandaag zijn gebruikt. Probeer het morgen opnieuw.",
            VISITOR_LIMIT: "Je hebt vandaag het maximale aantal fotovoorbeelden gemaakt. Morgen kun je weer verder.",
            DUPLICATE: "Dit verzoek is al verwerkt of nog bezig. Wacht op het resultaat of wijzig je foto of keuzes voor een nieuw voorbeeld.",
            INVALID_IMAGE: "Kies een gewone JPG-, PNG- of WebP-foto van minimaal 200 × 200 pixels.",
            TOO_LARGE: "Deze foto is te groot. Kies een kleinere versie.",
            INVALID_OPTIONS: "Controleer je gekozen vorm, afmeting en afwerking.",
            PRODUCT_NOT_SUPPORTED: "Voor dit product is het fotovoorbeeld niet beschikbaar."
          };
          throw new Error(messages[result && result.code] || "Het fotovoorbeeld is tijdelijk niet beschikbaar. Probeer het later opnieuw.");
        }
        // Alleen een succesvol afgeronde generatie krijgt bij een volgende klik een nieuw id.
        lastPhoto = lastChoice = "";
        return result;
      } catch (e) {
        if (e.name === "AbortError" || e instanceof TypeError) throw new Error("Het maken van je voorbeeld duurde te lang of de verbinding viel weg. Probeer het later opnieuw.");
        throw e;
      } finally { clearTimeout(timer); }
    };
  }

  async function leesFoto(file) {
    var fout = fotoFout(file);
    if (fout) throw new Error(fout);
    var url = URL.createObjectURL(file);
    try {
      var img = new Image();
      img.src = url;
      await img.decode();
      if (Math.min(img.naturalWidth, img.naturalHeight) < 200) throw new Error("Deze foto is te klein. Kies een foto van minimaal 200 × 200 pixels.");
      if (img.naturalWidth * img.naturalHeight > 40000000) throw new Error("Deze foto heeft te veel pixels. Kies een kleinere versie.");
      var scale = Math.min(1, 1000 / Math.max(img.naturalWidth, img.naturalHeight));
      var canvas = document.createElement("canvas");
      canvas.width = Math.round(img.naturalWidth * scale);
      canvas.height = Math.round(img.naturalHeight * scale);
      var ctx = canvas.getContext("2d");
      if (!ctx) throw new Error("Je browser kan deze foto niet verwerken. Probeer een andere browser.");
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      // Canvas maakt een nieuwe foto zonder EXIF, zoals locatiegegevens.
      var data = canvas.toDataURL("image/jpeg", .88);
      if (data.length > 2800000) data = canvas.toDataURL("image/jpeg", .7);
      if (data.length > 2800000) throw new Error("De foto is nog te groot. Kies een kleinere versie.");
      canvas.width = canvas.height = 0;
      return data;
    } catch (e) {
      if (e && e.name === "EncodingError") throw new Error("Deze foto kan niet worden geopend. Kies een andere JPG-, PNG- of WebP-foto.");
      throw e;
    } finally {
      URL.revokeObjectURL(url);
    }
  }

  /** Wat er op welk moment te melden valt. Een minuut stilte leest als vastgelopen. */
  var BEZIG_FASEN = [
    { vanaf: 0, tekst: "Je foto wordt verstuurd…" },
    { vanaf: 6, tekst: "De kamer wordt bekeken…" },
    { vanaf: 16, tekst: "Je vloerkleed wordt in de ruimte gelegd…", tapijt: "Je tapijt wordt van wand tot wand gelegd…" },
    { vanaf: 34, tekst: "Pluis, randafwerking en schaduw worden getekend…", tapijt: "Pluis, licht en schaduw worden getekend…" },
    { vanaf: 52, tekst: "Bijna klaar, nog heel even…" }
  ];
  /** De balk loopt naar 95% en wacht daar: 100% tonen terwijl er niets is, is een leugen. */
  function bezigFase(seconden, tapijt) {
    var fase = BEZIG_FASEN[0];
    for (var i = 0; i < BEZIG_FASEN.length; i++) if (seconden >= BEZIG_FASEN[i].vanaf) fase = BEZIG_FASEN[i];
    var s = Math.max(0, seconden);
    return { tekst: (tapijt && fase.tapijt) || fase.tekst, tijd: Math.round(s) + " sec", balk: Math.round(95 * (1 - Math.exp(-s / 22))) };
  }

  /** De impressie vervangt de eigen foto; beide tegelijk tonen leest als twee losse beelden. */
  function beeldZichtbaarheid(heeftFoto, heeftResultaat, toon) {
    var toontImpressie = !!heeftResultaat && toon === "impressie";
    return {
      beeld: !!heeftFoto && !toontImpressie,
      resultaat: toontImpressie,
      terugknop: toontImpressie,
      impressieknop: !!heeftResultaat && !toontImpressie
    };
  }

  /** generate is optioneel; zonder aansluiting blijft de knop uit en gaat niets over het netwerk. */
  function mount(panel, options) {
    if (!panel || panel.vmRuimte) return panel && panel.vmRuimte;
    var q = function (name) { return panel.querySelector("[data-vkm-ruimte-" + name + "]"); };
    var upload = q("upload"), button = q("genereer"), status = q("status");
    var photo = "", photoVersion = 0, busy = false, decoding = false, resultChoice = null;
    // "foto" of "impressie": de impressie vervangt de eigen foto, met een knop terug.
    var toon = "foto";
    var choice = null, destroyed = false;
    function melding(text, error) {
      status.textContent = text || "";
      status.toggleAttribute("data-fout", !!error);
    }
    function update() {
      if (destroyed) return;
      choice = options.getChoice();
      panel.hidden = !choice;
      q("keuze").textContent = keuzeTekst(choice);
      button.disabled = !photo || !choice || busy || decoding || !options.generate;
      var tapijt = isTapijt(choice);
      button.textContent = busy ? (tapijt ? "Je tapijt wordt in je ruimte gelegd…" : "Je vloerkleed wordt in je ruimte gelegd…")
        : (tapijt ? "Visualiseer mijn tapijt" : "Visualiseer mijn vloerkleed");
      if (q("titel")) q("titel").textContent = tapijt ? "Zie dit tapijt in je eigen ruimte" : (choice && choice.standaardmaat ? "Bekijk dit vloerkleed in je eigen ruimte" : "Zie dit kleed in je eigen ruimte");
      upload.disabled = busy;
      q("verwijder").disabled = busy;
      panel.setAttribute("aria-busy", String(busy || decoding));
      var zicht = beeldZichtbaarheid(photo, resultChoice, busy ? "foto" : toon);
      q("beeld").hidden = !zicht.beeld;
      q("resultaat").hidden = !zicht.resultaat;
      q("toonimpressie").hidden = !zicht.impressieknop;
      q("toonimpressie").disabled = busy;
      q("toonfoto").disabled = busy;
      if (resultChoice && !zelfdeKeuze(choice, resultChoice) && !busy) {
        melding("Je keuzes zijn gewijzigd. De afbeelding toont nog je vorige samenstelling. Maak een nieuw voorbeeld om je wijzigingen te bekijken.");
      }
    }
    function clearResult() {
      resultChoice = null;
      toon = "foto";
      q("resultaat").hidden = true;
      q("resultaatfoto").removeAttribute("src");
      q("download").removeAttribute("href");
    }
    function clearPhoto() {
      photoVersion++;
      photo = "";
      decoding = false;
      upload.value = "";
      q("preview").removeAttribute("src");
      q("bestand").textContent = "Voeg een foto van je ruimte toe";
      clearResult();
      melding("");
      update();
    }
    async function selectPhoto() {
      var file = upload.files[0];
      if (!file) return;
      clearPhoto();
      var version = photoVersion;
      decoding = true;
      melding("Je foto wordt voorbereid…");
      update();
      try {
        var data = await leesFoto(file);
        if (destroyed || version !== photoVersion) return;
        photo = data;
        q("preview").src = data;
        q("bestand").textContent = file.name;
        melding(options.generate ? "Je foto staat klaar. We gebruiken de keuzes hierboven." : "Je foto staat lokaal klaar. Het maken van AI-voorbeelden is nog niet ingeschakeld.");
      } catch (e) {
        if (!destroyed && version === photoVersion) melding(e.message || "Het voorbereiden van je foto is niet gelukt.", true);
      } finally {
        if (!destroyed && version === photoVersion) { decoding = false; update(); }
      }
    }
    async function generate() {
      update();
      if (button.disabled) return;
      var snapshot = JSON.parse(JSON.stringify(choice));
      var version = photoVersion;
      busy = true;
      melding("We maken een voorbeeld met jouw gekozen " + (isTapijt(snapshot) ? "tapijt" : "vloerkleed") + ". Dit duurt ongeveer een minuut.");
      toonBezig(true);
      update();
      try {
        var result = await options.generate({ photo: photo, choice: snapshot });
        if (destroyed || version !== photoVersion) return;
        if (!result || !veiligeResultaatData(result.image)) throw new Error("Er is geen bruikbare afbeelding ontvangen. Probeer het later opnieuw.");
        q("resultaatfoto").src = result.image;
        q("download").href = result.image;
        q("download").download = (isTapijt(snapshot) ? "mijn-tapijt" : "mijn-vloerkleed") + "-in-mijn-ruimte." + (result.image.indexOf("data:image/jpeg") === 0 ? "jpg" : result.image.indexOf("data:image/webp") === 0 ? "webp" : "png");
        q("resultaatkeuze").textContent = keuzeTekst(snapshot);
        resultChoice = snapshot;
        noteerImpressie(snapshot.productHandle);
        toon = "impressie";
        melding("Je voorbeeld is klaar. Je eigen foto blijft beschikbaar onder de knop.");
      } catch (e) {
        if (!destroyed) melding(e.message || "Het maken van je voorbeeld is niet gelukt. Probeer het later opnieuw.", true);
      } finally {
        busy = false;
        toonBezig(false);
        update();
      }
    }
    var bezigTimer = null, bezigStart = 0;
    function toonBezig(aan) {
      var vak = q("bezig");
      if (bezigTimer) { clearInterval(bezigTimer); bezigTimer = null; }
      vak.hidden = !aan;
      if (!aan) { q("balk").style.width = "0%"; return; }
      bezigStart = Date.now();
      var tik = function () {
        var fase = bezigFase((Date.now() - bezigStart) / 1000, isTapijt(choice));
        q("bezigtekst").textContent = fase.tekst;
        q("bezigtijd").textContent = fase.tijd;
        q("balk").style.width = fase.balk + "%";
      };
      tik();
      bezigTimer = setInterval(tik, 1000);
    }
    function wisselNaarFoto() { toon = "foto"; update(); }
    function wisselNaarImpressie() { toon = "impressie"; update(); }
    upload.addEventListener("change", selectPhoto);
    q("verwijder").addEventListener("click", clearPhoto);
    q("toonfoto").addEventListener("click", wisselNaarFoto);
    q("toonimpressie").addEventListener("click", wisselNaarImpressie);
    button.addEventListener("click", generate);
    panel.vmRuimte = {
      update: update,
      destroy: function () {
        destroyed = true;
        toonBezig(false);
        photoVersion++;
        photo = "";
        upload.removeEventListener("change", selectPhoto);
        q("verwijder").removeEventListener("click", clearPhoto);
        q("toonfoto").removeEventListener("click", wisselNaarFoto);
        q("toonimpressie").removeEventListener("click", wisselNaarImpressie);
        button.removeEventListener("click", generate);
        q("preview").removeAttribute("src");
        clearResult();
        delete panel.vmRuimte;
      }
    };
    update();
    return panel.vmRuimte;
  }
  global.VMRuimte = { mount: mount, generator: generator, fotoFout: fotoFout, keuzeTekst: keuzeTekst,
    zelfdeKeuze: zelfdeKeuze, veiligeResultaatData: veiligeResultaatData,
    beeldZichtbaarheid: beeldZichtbaarheid, bezigFase: bezigFase, hadImpressie: hadImpressie };
})(typeof window !== "undefined" ? window : globalThis);

/* vm-vloerkleed-op-maat
   Configurator voor vloerkleden en trapmatten op maat.

   Oppervlakte en randlengte worden uit het vormpad zelf gemeten: het pad wordt
   op 720 punten bemonsterd en naar centimeters geschaald, daarna volgt de
   oppervlakte uit de shoelace-formule en de rand uit de segmentlengtes. De
   tekening en de prijs gebruiken dus dezelfde bron en kunnen niet uit elkaar
   lopen.

   Afrekenen gaat via een maatwerk-product: de prijs wordt omgezet naar een
   aantal eenheden van dat product. Zie de sectie voor de toelichting. */
(function () {
  "use strict";

  var NS = "http://www.w3.org/2000/svg";

  var VORMEN = [
    // vrij: lengte en breedte los in te vullen. Een rechthoek heeft geen vaste verhouding; een klant
    // die 200 x 300 wil, moet dat kunnen bestellen (stond vast op 74:100, Faruk 12-10-2026).
    { id: "rechthoek", naam: "Rechthoek", invoer: "lb", vrij: true, snij: "recht", icoon: [74, 100], d: "M0 0H100V100H0Z",
      uitleg: "Rechthoekig kleed. Je vult lengte en breedte los in, inclusief randafwerking. Wil je ronde hoeken, vul dan een hoekradius in." },
    { id: "vierkant", naam: "Vierkant", invoer: "zijde", snij: "recht", icoon: [92, 92], d: "M0 0H100V100H0Z",
      uitleg: "Vierkant kleed met rechte hoeken. Je vult \u00e9\u00e9n maat in, die geldt voor lengte en breedte." },
    { id: "rond", naam: "Rond", invoer: "diameter", snij: "rond", icoon: [96, 96], d: "M50 0A50 50 0 0 1 50 100A50 50 0 0 1 50 0Z",
      uitleg: "Rond kleed. Je vult de diameter in, dat is de doorsnede inclusief randafwerking." },
    { id: "ellips", naam: "Ellips", invoer: "lb", snij: "rond", icoon: [74, 100], d: "M50 0A50 50 0 0 1 50 100A50 50 0 0 1 50 0Z",
      uitleg: "Lengte en breedte lopen gelijkwaardig afbuigend mee in de ellipsvorm, met volledig ronde hoeken." },
    { id: "ovaal", naam: "Ovaal", invoer: "lb", snij: "rond", icoon: [74, 100], d: "M0 37A50 37 0 0 1 100 37V63A50 37 0 0 1 0 63Z",
      uitleg: "Een stadionvorm: ronde koppen aan de korte zijden met rechte lijnen ertussen. Lengte en breedte veranderen samen." },
    { id: "cube", naam: "Cube", invoer: "zijde", snij: "recht", icoon: [92, 92], d: "M18 0H82Q100 0 100 18V82Q100 100 82 100H18Q0 100 0 82V18Q0 0 18 0Z",
      uitleg: "Vierkant kleed met ronde hoeken. Je vult één maat in en kiest zelf hoe rond de hoeken worden (hoekradius)." },
    { id: "pebble", naam: "Pebble", invoer: "lb", snij: "speciaal", icoon: [100, 70], d: "M30 0C44 0 58 13 70 27C82 41 100 43 100 61C100 86 72 100 33 100C12 100 0 78 0 47C0 19 12 0 30 0Z",
      uitleg: "Kiezelvorm met ronde, ongelijke hoeken. Lengte en breedte lopen gelijkwaardig mee in de vorm." },
    { id: "stone", naam: "Stone", invoer: "lb", snij: "speciaal", icoon: [100, 76], d: "M44 0C62 0 83 3 93 9C98 12 100 17 100 25C100 46 65 85 43 97C39 99 35 100 31 100C12 100 0 80 0 44C0 13 13 0 44 0Z",
      uitleg: "Steenvorm met ronde hoeken en een licht asymmetrische lijn." }
  ];

  var RONDOM_FRANJE = ["rond", "ovaal", "ellips"];
  var TRAPPAD_ROND = "M0 100V38Q50 -16 100 38V100Z";
  var TRAPPAD_RECHT = "M0 0H100V100H0Z";
  var MAAT_LB = [200, 240, 300, 380];
  var MAAT_RECHT = [[160, 230], [200, 300], [240, 340], [280, 380]]; // [breedte, lengte] voor vrije vormen
  var MAAT_ENKEL = [100, 150, 180, 200, 250];

  var euroFmt = new Intl.NumberFormat("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function euro(n) { return "€ " + euroFmt.format(n); }
  // Zoals de money-filter van de winkel (zonder spatie): de kop blijft gelijk aan de server-HTML en de PDP.
  function geld(n) { return "€" + euroFmt.format(n); }
  function getal(n, d) {
    if (d === undefined) d = 2;
    return n.toLocaleString("nl-NL", { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function num(v, terug) {
    var n = parseFloat(String(v === undefined || v === null ? "" : v).replace(",", "."));
    return isNaN(n) ? terug : n;
  }

  function maatGetal(n) {
    return n.toLocaleString("nl-NL", { maximumFractionDigits: 2 });
  }

  // Kleedmaten in stappen van 5 cm, altijd naar boven afgerond (Faruk 19-10: 203 cm wordt 205 cm).
  function op5(cm) { return Math.ceil(cm / 5 - 1e-9) * 5; }
  function vasteVormMaten(v, naam, waarde, minMaat) {
    if (!Number.isFinite(waarde) || ["lengte", "breedte", "diameter"].indexOf(naam) === -1) return null;
    var iB = v.icoon[0], iL = v.icoon[1];
    var minimum = Math.max(50, minMaat);
    var kleinste = Math.max(minimum / iB, minimum / iL);
    var grootste = Math.min(500 / iB, 2500 / iL);
    if (!Number.isFinite(kleinste) || kleinste > grootste) return null;
    // Begrens de schaal als geheel; los begrenzen zou de vorm vervormen.
    var schaal = Math.max(kleinste, Math.min(grootste, waarde / (naam === "lengte" ? iL : iB)));
    return { B: iB * schaal, L: iL * schaal };
  }

  /* De rolbreedte is bij een kleed op maat geen klantkeuze. De kleinste maat moet binnen
     de rolbreedte passen, de andere loopt mee in de lengte van de baan. Zonder
     snijverlies nemen we de smalste passende rol. Met snijverlies betaal je rol x baan
     en kan een bredere rol goedkoper zijn, als de lange zijde er dan dwars in past
     (300 x 450: 4 x 4,5 = 18 m2 tegen 5 x 3 = 15 m2); dan nemen we de goedkoopste.
     Past geen enkele rol, dan de breedste; de maatmelding geeft dan een foutmelding en
     bestellen kan niet. "Past" = binnen de rol min de snijmarge aan beide kanten. */
  // Snijmarge in cm per kant. Alleen bij volumekarpet; bij festonneren, banderen enz. wordt het
  // tapijt op de maat van het kleed gesneden (Faruk 20-10). Ook de pasmarge langs de muren bij
  // kamerbreed tapijt (rekenhulp) is 10 cm; die staat los hiervan.
  var SNIJMARGE = 10;
  function bruikbaar(rol, marge) { return rol - 2 * (Number(marge) || 0); }
  function kiesRolbreedte(rolbreedtes, B, L, snijverlies, marge) {
    marge = Number(marge) || 0;
    var lijst = (rolbreedtes || []).map(Number).filter(function (b) { return b > 0; })
      .sort(function (a, b) { return a - b; });
    if (!lijst.length) return 400;
    var kort = Math.min(B, L), lang = Math.max(B, L);
    var passend = lijst.filter(function (b) { return kort <= bruikbaar(b, marge); });
    if (!passend.length) return lijst[lijst.length - 1];
    if (!snijverlies) return passend[0];
    var beste = passend[0], kosten = Infinity;
    passend.forEach(function (b) {
      var k = b * ((lang > bruikbaar(b, marge) ? lang : kort) + 2 * marge);
      if (k < kosten - 1e-9) { kosten = k; beste = b; }
    });
    return beste;
  }

  function start(root) {
    var cfgEl = root.querySelector("[data-vkm-config]");
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    cfg.eenheidPrijs = num(cfg.eenheidPrijs, 1);
    cfg.prijsM2 = num(cfg.prijsM2, 0);
    cfg.antislipM2 = num(cfg.antislipM2, 12.5);
    cfg.confectie = num(cfg.confectie, 19.95);
    cfg.minMaat = num(cfg.minMaat, 50);
    cfg.minTrapmatten = num(cfg.minTrapmatten, 12);

    var kleuren = cfg.kleuren || [];
    var randkleuren = (cfg.randkleuren || []).filter(function (k) { return k && k.hex; });
    // Rolbreedtes van de gekozen kleur (variantmetaveld custom.rolbreedte; bij Belakos Suspense
    // bestaat alleen kleur 62 op 500 cm, de rest op 400), anders die van het product. Faruk 19-10.
    // Snijmarge per kant voor het gekozen kleed: alleen volumekarpet (zie SNIJMARGE).
    function marge() { var g = groep(); return s.modus === "kleed" && g && g.soort === "volume" ? SNIJMARGE : 0; }
    function rollen() {
      var k = kleuren[s.kleur];
      var lijst = k && Array.isArray(k.rollen) && k.rollen.length ? k.rollen : (cfg.rolbreedtes || []);
      lijst = lijst.map(Number).filter(function (b) { return b > 0; });
      return lijst.length ? lijst : [400];
    }
    var trapvormen = (cfg.trapvormen || []).map(function (t) {
      return { naam: t.naam || "Trapmat", b: num(t.b, 56), d: num(t.d, 19), rond: !!t.rond };
    });

    /* afwerkingen groeperen: blokken met dezelfde groep vormen samen een keuze
       met een aparte breedtestap, zoals bij festonneren smal/standaard. */
    var groepen = [];
    (cfg.afwerkingen || []).forEach(function (a) {
      var sleutel = (a.groep || a.naam || a.id || "").toString().toLowerCase() || a.id;
      var g = null;
      for (var i = 0; i < groepen.length; i++) { if (groepen[i].sleutel === sleutel) { g = groepen[i]; break; } }
      if (!g) {
        g = { sleutel: sleutel, naam: a.naam, soort: a.soort || "feston", uitleg: a.uitleg || "",
              antislipInbegrepen: !!a.antislipInbegrepen, alleenKorteZijde: !!a.alleenKorteZijde, breedtes: [] };
        groepen.push(g);
      }
      if (a.antislipInbegrepen) g.antislipInbegrepen = true;
      if (a.alleenKorteZijde) g.alleenKorteZijde = true;
      if (a.uitleg && !g.uitleg) g.uitleg = a.uitleg;
      if (a.foto && !g.foto) g.foto = a.foto;
      g.breedtes.push({ id: a.id, naam: a.sub || a.naam, sub: a.sub || "", cm: num(a.cm, 1), prijs: num(a.prijs, 0) });
    });

    if (!kleuren.length || !groepen.length || !randkleuren.length) {
      root.setAttribute("data-vkm-onvolledig", "1");
    }

    var ICO_METER = '<path d="M4 5l8 7 8-7M4 19l8-7 8 7"/>';
    var ICO_KLEED = '<path d="M3 14L14 3l7 7L10 21z"/><path d="M7 10l2 2M10 7l2 2M13 14l2 2"/>';
    var MODI = [];
    if (cfg.toonMeter !== false) {
      MODI.push({ id: "meter", naam: "Per strekkende meter", sub: "Van de rol, onafgewerkt",
        ico: ICO_METER,
        uitleg: "Deze vloerbedekking zit op een rol. Neem je 1 meter van die rol in de lengte, dan is dat een strekkende meter. Je krijgt de baan onafgewerkt geleverd." });
    }
    // Op het template voor kamerbreed tapijt staat "vloerkleed op maat" uit (toon_kleed): dat is
    // daar een eigen product, en stap 2 linkt ernaar (zie tweelingKnop).
    if (cfg.toonKleed !== false || !MODI.length) {
      MODI.push({ id: "kleed", naam: "Vloerkleed op maat", sub: "Afgewerkt, " + VORMEN.length + " vormen",
        ico: ICO_KLEED,
        uitleg: "Kies een vorm, een maat, de randafwerking met bijbehorende breedte, de afwerkkleur en eventueel een anti-slip onderkleed. We maken je kleed in ons eigen atelier." });
    }
    if (cfg.toonTrapmatten !== false && trapvormen.length) {
      MODI.push({ id: "trap", naam: "Trapmatten op maat", sub: "Per trede, rondom af",
        ico: '<path d="M3 20h5v-5h5v-5h5V5"/>',
        uitleg: "Losse matten per trede, rondom gefestonneerd en voorzien van een anti-slip rug. Kies een vaste maat en het aantal treden." });
    }

    var s = {
      kleur: 0,
      modus: MODI.some(function (o) { return o.id === "kleed"; }) ? "kleed" : MODI[0].id,
      vorm: "rechthoek",
      lengte: 300, breedte: 200, diameter: 200,
      radius: { rechthoek: 0, cube: 35 },  // hoekradius in cm per vorm; 0 = rechte hoeken
      rolbreedte: (cfg.rolbreedtes && cfg.rolbreedtes[0]) || 400,
      groep: groepen.length ? groepen[0].sleutel : null,
      randbreedte: groepen.length && groepen[0].breedtes.length ? groepen[0].breedtes[0].id : null,
      randkleur: 0,
      antislip: false, antislipDikte: "1", // altijd 1 mm; de diktekeuze is vervallen (besluit Faruk 28-09)
      meters: 4, kamerL: 5.2, kamerB: 3.8,
      trapvorm: 0, treden: Math.max(cfg.minTrapmatten, 13),
      stuks: 1,           // aantal kleden van deze maat (alleen modus kleed)
      beeld: 0            // 0 = schaaltekening, daarna de sfeerfoto's
    };

    /* ---------- staaltjes per kleur ---------- */
    // Elke kleur heeft een eigen staalvariant ("Staal <kleur>", € 0). De stalenmand zelf is van
    // assets/sample.js (cookie "samples", max 3, dezelfde lade en afrekenknop); die is een module en
    // geeft daarom window.vmStalenmand als ingang. Per KLEUR: twee kleuren van één kwaliteit mogen
    // naast elkaar in de mand. sections/vm-staal.liquid gebruikt window.vkmStaal en "vkm:kleur".
    function staalKleur(i) {
      var k = kleuren[i == null ? s.kleur : i];
      return cfg.staalAan && k && k.staal ? k : null;
    }
    function staalInMand(i) {
      var k = staalKleur(i);
      if (!k) return false;
      if (window.vmStalenmand) return window.vmStalenmand.bevat(k.staal.id);
      var m = document.cookie.match(/(?:^|; )samples=([^;]*)/);
      try { return (m ? JSON.parse(decodeURIComponent(m[1])) : []).some(function (x) { return String(x.variant) === String(k.staal.id); }); }
      catch (e) { return false; }
    }
    function voegStaalToe() {
      var k = staalKleur();
      if (!k) return { ok: false, reden: "geen" };
      if (!window.vmStalenmand) return { ok: false, reden: "mand" };
      var titel = (cfg.productTitel || "") + " - " + k.titel;
      var uit = window.vmStalenmand.voegToe({ id: k.staal.id, variant: k.staal.id, title: titel, image: k.beeld, handle: cfg.productHandle, url: cfg.productUrl, price: 0, sku: k.staal.sku });
      return { ok: uit === "ok", reden: uit };
    }
    function kleurInfo() {
      var k = kleuren[s.kleur] || {};
      return { titel: k.titel || "", beeld: k.beeldGroot || k.beeld || "", staal: !!staalKleur(), inMand: staalInMand() };
    }
    function meldKleur() {
      tekenStaalknop();
      try { document.dispatchEvent(new CustomEvent("vkm:kleur", { detail: kleurInfo() })); } catch (e) { /* oude browser: staalkaart blijft op de vorige kleur */ }
    }
    // Knop "Vraag een staal aan" in stap 1 (data-vkm-staal in sections/vm-vloerkleed-op-maat.liquid).
    // Ligt het staal al in de mand, dan opent een klik de lade (voegToe geeft dan "al").
    var staalRij = root.querySelector("[data-vkm-staal]");
    var staalMelding = "", staalMeldingKleur = -1;
    function tekenStaalknop() {
      if (!staalRij) return;
      var k = staalKleur();
      staalRij.hidden = !k;
      if (!k) return;
      if (staalMeldingKleur !== s.kleur) staalMelding = "";
      var inMand = staalInMand();
      staalRij.querySelector("[data-vkm-staal-knop]").classList.toggle("is-in-mand", inMand);
      staalRij.querySelector("[data-vkm-staal-tekst]").textContent = inMand ? "Staal ligt in je stalenmand" : "Vraag een staal aan";
      var noot = staalRij.querySelector("[data-vkm-staal-noot]");
      noot.textContent = staalMelding || (inMand ? "" : "Gratis, in de kleur " + (k.titel || ""));
      noot.classList.toggle("is-fout", !!staalMelding);
    }
    if (staalRij) {
      staalRij.querySelector("[data-vkm-staal-knop]").addEventListener("click", function () {
        var r = voegStaalToe();
        staalMelding = r.reden === "vol" ? "Je stalenmand zit vol (maximaal 3). Verwijder eerst een staal."
          : r.reden === "mand" ? "De stalenmand laadt nog, probeer het zo opnieuw." : "";
        staalMeldingKleur = s.kleur;
        meldKleur();
      });
      // Een staal verwijderen in de lade maakt de knop weer "Vraag een staal aan".
      document.addEventListener("click", function (e) {
        if (e.target.closest && e.target.closest(".sample-drawer__sample__remove")) setTimeout(function () { staalMelding = ""; meldKleur(); }, 300);
      });
    }
    document.addEventListener("vm:stalenmand-klaar", meldKleur);
    window.vkmStaal = { voegToe: voegStaalToe, info: kleurInfo };

    function vorm() {
      for (var i = 0; i < VORMEN.length; i++) { if (VORMEN[i].id === s.vorm) return VORMEN[i]; }
      return VORMEN[0];
    }
    function groep() {
      for (var i = 0; i < groepen.length; i++) { if (groepen[i].sleutel === s.groep) return groepen[i]; }
      return groepen[0];
    }
    function randbreedte() {
      var g = groep();
      if (!g) return { cm: 1, prijs: 0, naam: "", sub: "" };
      for (var i = 0; i < g.breedtes.length; i++) { if (g.breedtes[i].id === s.randbreedte) return g.breedtes[i]; }
      return g.breedtes[0];
    }
    /* Rechthoek en cube: de hoekradius (cm) kiest de klant zelf, van 0 (rechte hoeken) tot de
       helft van de kortste zijde. Rechthoek start op 0, cube op 35 cm. Het pad wordt per radius
       opgebouwd met echte cirkelbogen, zodat tekening, oppervlak en randlengte (en dus de
       afwerkingsprijs) bij de gekozen hoeken horen. */
    function heeftRadius(v) { return s.radius[v.id] !== undefined; }
    function korteZijde(v) { return v.invoer === "zijde" ? s.breedte : Math.min(s.breedte, s.lengte); }
    function radiusMax(v) { return korteZijde(v) / 2; }
    function hoekradius(v) { return Math.min(radiusMax(v), Math.max(0, s.radius[v.id])); }
    // Pad in de 0-100-ruimte voor een kleed van B x L met hoekradius r (allemaal in dezelfde eenheid).
    function radiusPad(B, L, r) {
      if (!(r > 0)) return "M0 0H100V100H0Z";
      var rond2 = function (n) { return Math.round(n * 100) / 100; };
      var rx = rond2(r / B * 100), ry = rond2(r / L * 100), ex = rond2(100 - rx), ey = rond2(100 - ry);
      var a = "A" + rx + " " + ry + " 0 0 1 ";
      return "M" + rx + " 0H" + ex + a + "100 " + ry + "V" + ey + a + ex + " 100H" + rx + a + "0 " + ey + "V" + ry + a + rx + " 0Z";
    }
    function vormPad(v) {
      if (!heeftRadius(v)) return v.d;
      return radiusPad(s.breedte, v.invoer === "zijde" ? s.breedte : s.lengte, hoekradius(v));
    }
    // Vormtegel: vaste weergaveverhouding, dus de radius naar verhouding van de korte zijde.
    // Niet-gekozen tegels houden hun vaste beeld.
    function tegelPad(v) {
      if (v.id !== s.vorm || !heeftRadius(v)) return v.d;
      var iB = v.icoon[0], iL = v.icoon[1];
      return radiusPad(iB, iL, hoekradius(v) / korteZijde(v) * Math.min(iB, iL));
    }
    function vormNaamMaat(v) {
      if (!heeftRadius(v)) return v.naam;
      var r = Math.round(hoekradius(v));
      if (r > 0) return v.naam + ", hoekradius " + maatGetal(r) + " cm";
      return v.id === "rechthoek" ? v.naam : v.naam + ", rechte hoeken";
    }
    // m2-prijs van de gekozen kleur (variantprijs); de sectieprijs is alleen de terugval.
    function prijsM2() { var kp = kleuren[s.kleur] && num(kleuren[s.kleur].prijs, 0); return kp > 0 ? kp : cfg.prijsM2; }
    function adviesM2() { var kp = kleuren[s.kleur] && num(kleuren[s.kleur].prijs, 0); return kp > 0 ? num(kleuren[s.kleur].advies, 0) : num(cfg.adviesM2, 0); }
    // Kopveld bijwerken (alleen bij verschil: teken() draait bij elke invoer). Met zichtbaar/blokSel
    // ook het omringende blok tonen of verbergen, zoals de adviesprijs bij een kleur zonder korting.
    function kopZet(sel, tekst, zichtbaar, blokSel) {
      var el = root.querySelector(sel);
      if (el && el.textContent !== tekst) el.textContent = tekst;
      var blok = blokSel && root.querySelector(blokSel);
      if (blok && blok.hidden === !!zichtbaar) blok.hidden = !zichtbaar;
    }
    function meters() { return Math.max(1, Math.ceil(s.meters * 20) / 20); }
    function treden() { return Math.max(cfg.minTrapmatten, Math.round(s.treden)); }
    var MAX_STUKS = 20;
    // Aantal stuks van deze maat: kleden, of banen van de rol (kamerbreed). Trapmatten tellen al per trede.
    function heeftStuks() { return s.modus === "kleed" || s.modus === "meter"; }
    function stuks() { return heeftStuks() ? Math.min(MAX_STUKS, Math.max(1, Math.round(s.stuks) || 1)) : 1; }

    /* ---------- meten ---------- */
    var meetSvg = root.querySelector("[data-vkm-meet]");
    var meetCache = {};
    function meetPad(d, bCm, lCm) {
      var sleutel = d + "|" + bCm + "|" + lCm;
      if (meetCache[sleutel] !== undefined) return meetCache[sleutel];
      var res = null;
      try {
        var pad = document.createElementNS(NS, "path");
        pad.setAttribute("d", d);
        meetSvg.appendChild(pad);
        var L = pad.getTotalLength();
        if (L > 0) {
          var N = 720, sx = bCm / 100, sy = lCm / 100;
          var vx = 0, vy = 0, x0 = 0, y0 = 0, opp = 0, omtrek = 0;
          for (var i = 0; i <= N; i++) {
            var q = pad.getPointAtLength(L * i / N);
            var x = q.x * sx, y = q.y * sy;
            if (i === 0) { x0 = x; y0 = y; }
            else { opp += vx * y - x * vy; omtrek += Math.sqrt((x - vx) * (x - vx) + (y - vy) * (y - vy)); }
            vx = x; vy = y;
          }
          opp += vx * y0 - x0 * vy;
          omtrek += Math.sqrt((x0 - vx) * (x0 - vx) + (y0 - vy) * (y0 - vy));
          res = { opp: Math.abs(opp) / 2 / 10000, omtrek: omtrek / 100 };
        }
        meetSvg.removeChild(pad);
      } catch (e) { res = null; }
      meetCache[sleutel] = res;
      return res;
    }

    function kiesRol() {
      if (s.modus !== "kleed") return;
      var v = vorm(), B, L;
      if (v.invoer === "diameter") { B = s.diameter; L = s.diameter; }
      else if (v.invoer === "zijde") { B = s.breedte; L = s.breedte; }
      else { B = s.breedte; L = s.lengte; }
      s.rolbreedte = kiesRolbreedte(rollen(), B, L, cfg.snijverliesDoorbelasten, marge());
    }

    function maten() {
      var v = vorm(), B, L;
      if (v.invoer === "diameter") { B = s.diameter; L = s.diameter; }
      else if (v.invoer === "zijde") { B = s.breedte; L = s.breedte; }
      else { B = s.breedte; L = s.lengte; }
      var g = meetPad(vormPad(v), B, L);
      var opp = g ? g.opp : (B / 100) * (L / 100);
      var omtrek = g ? g.omtrek : 2 * (B / 100 + L / 100);
      var gr = groep();
      if (gr && gr.alleenKorteZijde && RONDOM_FRANJE.indexOf(v.id) === -1) omtrek = 2 * (B / 100);
      var snij = (B / 100) * (L / 100), baan = 0;
      if (cfg.snijverliesDoorbelasten) {
        /* De leverancier rekent het stuk dat van de rol gaat: de volle rolbreedte maal de
           lengte van de baan. Die baan is de kortste zijde; alleen als de langste zijde niet
           binnen de rol past, loopt die mee in de lengte. Eerder stond hier altijd L, zodat
           een kleed van 200 x 300 als 12 m2 werd gerekend in plaats van 8. */
        // Snijmarge (alleen volumekarpet, Faruk 20-10) ook in de lengte van de baan, aan beide kanten.
        baan = (Math.max(B, L) > bruikbaar(s.rolbreedte, marge()) ? Math.max(B, L) : Math.min(B, L)) + 2 * marge();
        snij = (s.rolbreedte / 100) * (baan / 100);
      }
      return { B: B, L: L, opp: opp, omtrek: omtrek, snij: snij, baan: baan };
    }

    /* Een kleed is uit één stuk: de kortste zijde moet binnen de breedste rol passen, min de
       snijmarge aan beide kanten. Geeft de foutmelding terug, of "" als het past. */
    function kleedTeGroot() {
      if (s.modus !== "kleed") return "";
      var mt = maten();
      var breedste = Math.max.apply(null, rollen().concat([0]));
      var max = bruikbaar(breedste, marge());
      if (Math.min(mt.B, mt.L) <= max) return "";
      return "Dit kleed is te groot. Een vloerkleed is maximaal " + max + " cm breed: onze breedste rol is " + breedste + " cm" +
        (marge() ? " en bij volumekarpet houden we " + marge() + " cm snijmarge aan elke kant" : "") +
        ". Maak de kortste zijde " + max + " cm of kleiner.";
    }

    /* ---------- tekeningen ---------- */
    var tapijtKleuren = Object.create(null);
    function tapijtHex() {
      var k = kleuren[s.kleur];
      var bron = k && (k.beeld || k.beeldGroot);
      var terug = "#9A9188";
      if (!bron) return terug;
      if (Object.prototype.hasOwnProperty.call(tapijtKleuren, bron)) return tapijtKleuren[bron] || terug;
      tapijtKleuren[bron] = null;
      var afbeelding = new Image();
      afbeelding.crossOrigin = "anonymous";
      afbeelding.onload = function () {
        try {
          var canvas = document.createElement("canvas");
          canvas.width = canvas.height = 16;
          var context = canvas.getContext("2d");
          if (!context) throw new Error("Canvas niet beschikbaar");
          // Neem het midden van de staalfoto, zonder de buitenrand van de foto.
          context.drawImage(afbeelding, afbeelding.naturalWidth * 0.2, afbeelding.naturalHeight * 0.2,
            afbeelding.naturalWidth * 0.6, afbeelding.naturalHeight * 0.6, 0, 0, 16, 16);
          var pixels = context.getImageData(0, 0, 16, 16).data;
          var rood = 0, groen = 0, blauw = 0, gewicht = 0;
          for (var i = 0; i < pixels.length; i += 4) {
            var alpha = pixels[i + 3] / 255;
            rood += pixels[i] * alpha; groen += pixels[i + 1] * alpha; blauw += pixels[i + 2] * alpha;
            gewicht += alpha;
          }
          if (gewicht) tapijtKleuren[bron] = "rgb(" + Math.round(rood / gewicht) + "," +
            Math.round(groen / gewicht) + "," + Math.round(blauw / gewicht) + ")";
        } catch (e) {
          console.warn("[vloerkleed] Kon de voorbeeldkleur voor de rand niet bepalen.");
        }
        var actief = kleuren[s.kleur];
        if (actief && (actief.beeld || actief.beeldGroot) === bron) teken();
      };
      afbeelding.onerror = function () {
        console.warn("[vloerkleed] Kon de staalfoto voor de voorbeeldkleur niet laden.");
      };
      afbeelding.src = bron;
      return terug;
    }
    function randHex() {
      if (cfg.toonRandkleur === false) return tapijtHex();
      var gekozen = randkleuren[s.randkleur];
      return gekozen ? gekozen.hex : tapijtHex();
    }
    function hoekTekening(g) {
      var W = 150, H = 150;
      var rk = randHex();
      var cm = (g.sleutel === s.groep ? randbreedte().cm : g.breedtes[0].cm);
      var bb = Math.max(4, Math.min(22, cm * 2.4));
      var onder = '<polygon points="0,' + (H - bb) + " " + (W - bb) + "," + (H - bb) + " " + W + "," + H + " 0," + H + '"/>';
      var rechts = '<polygon points="' + (W - bb) + ",0 " + W + ",0 " + W + "," + H + " " + (W - bb) + "," + (H - bb) + '"/>';
      var band;
      if (g.soort === "franje") {
        band = "";
        for (var i = 5; i < W - 3; i += 5) {
          band += '<path d="M' + i + " " + (H - 15) + 'q1.7 8 -.7 15" stroke="' + rk + '" stroke-width="1.7" fill="none"/>';
        }
      } else if (g.soort === "blind") {
        band = '<g fill="' + tapijtHex() + '">' + onder + rechts + '</g><g fill="rgba(0,0,0,.22)">' + onder + rechts + "</g>";
      } else if (g.soort === "volume") {
        band = '<g fill="' + rk + '">' + onder + rechts + "</g>" +
          '<g fill="rgba(255,255,255,.30)"><rect x="0" y="' + (H - bb) + '" width="' + (W - bb) + '" height="' + (bb * 0.4) + '"/>' +
          '<rect x="' + (W - bb) + '" y="0" width="' + (bb * 0.4) + '" height="' + (H - bb) + '"/></g>';
      } else {
        band = '<g fill="' + rk + '">' + onder + rechts + "</g>";
        if (g.soort === "lint") {
          band += '<path d="M0 ' + (H - bb - 2.5) + "H" + (W - bb - 2.5) + "M" + (W - bb - 2.5) + " " + (H - bb - 2.5) +
            'V0" stroke="rgba(255,255,255,.7)" stroke-width="1.3" stroke-dasharray="3 3" fill="none"/>';
        }
      }
      var k = kleuren[s.kleur];
      var vulling = k && (k.beeldGroot || k.beeld)
        ? '<image href="' + (k.beeldGroot || k.beeld) + '" x="0" y="0" width="' + W + '" height="' + (H - 2) + '" preserveAspectRatio="xMidYMid slice"/>'
        : '<rect width="' + W + '" height="' + (H - 2) + '" fill="' + tapijtHex() + '"/>';
      return '<svg viewBox="0 0 ' + W + " " + H + '" role="presentation" aria-hidden="true">' +
        '<rect width="' + W + '" height="' + H + '" fill="var(--vkm-vloer)"/>' +
        vulling + band + "</svg>";
    }

    var planSvg = root.querySelector("[data-vkm-plan]");
    var pijlId = "vkm-pijl-" + (root.getAttribute("data-section-id") || "x");
    function tekenPlan() {
      var W = 720, H = 560, vak = { x: 100, y: 46, w: W - 100 - 46, h: H - 80 - 46 };
      var rk = randHex();
      var B, L, d = TRAPPAD_RECHT, titel, bandCm = 0;

      if (s.modus === "meter") {
        B = s.rolbreedte; L = meters() * 100; titel = "Baan van de rol";
      } else if (s.modus === "trap") {
        var t = trapvormen[s.trapvorm] || { naam: "Trapmat", b: 56, d: 19, rond: true };
        B = t.b; L = t.d; bandCm = 1;
        d = t.rond ? TRAPPAD_ROND : TRAPPAD_RECHT;
        titel = t.naam + " trapmat, " + treden() + " stuks";
      } else {
        var m = maten();
        B = m.B; L = m.L; d = vormPad(vorm()); bandCm = randbreedte().cm;
        titel = vorm().naam + " " + maatGetal(B) + " bij " + maatGetal(L) + " cm";
      }

      var sc = Math.min(vak.w / B, vak.h / L);
      var w = B * sc, h = L * sc;
      var x = vak.x + (vak.w - w) / 2, y = vak.y + (vak.h - h) / 2;
      var bandPx = Math.max(10, bandCm * sc * 2);   // de helft valt binnen de clip, dus dubbel tekenen
      var tf = "translate(" + x + "," + y + ") scale(" + (w / 100) + "," + (h / 100) + ")";
      var stap = 50 * sc;
      var k = kleuren[s.kleur];

      function maatlijn(x1, y1, x2, y2, label, onder) {
        var mx = (x1 + x2) / 2, my = (y1 + y2) / 2;
        return '<g><line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 +
          '" stroke="currentColor" stroke-width="1" marker-start="url(#' + pijlId + ')" marker-end="url(#' + pijlId + ')"/>' +
          '<text x="' + (onder ? mx : mx - 7) + '" y="' + (onder ? my + 18 : my) + '" text-anchor="' + (onder ? "middle" : "end") + '" ' +
          (onder ? "" : 'dominant-baseline="middle" ') + 'font-size="13" fill="currentColor">' + label + "</text></g>";
      }

      var gr = groep();
      var franjeAan = (s.modus === "kleed" && gr && gr.soort === "franje");
      var franjes = "";
      if (franjeAan && RONDOM_FRANJE.indexOf(s.vorm) === -1) {
        var lf = Math.min(26, Math.max(11, 10 * sc));
        for (var fx = x + 3; fx < x + w - 2; fx += 7) {
          franjes += '<path d="M' + fx + " " + (y + h) + "q2 " + (lf * 0.6) + " -.8 " + lf + '" stroke="' + rk + '" stroke-width="1.6" fill="none"/>' +
            '<path d="M' + fx + " " + y + "q2 -" + (lf * 0.6) + " -.8 -" + lf + '" stroke="' + rk + '" stroke-width="1.6" fill="none"/>';
        }
      }

      var vulId = "vkm-vul-" + (root.getAttribute("data-section-id") || "x");
      var vulId2 = vulId + "-b";
      var kbeeld = k && (k.beeldGroot || k.beeld);
      var vulDef = kbeeld
        ? (function () {
            // De structuur staat vast op het scherm: de fototegel is altijd hetzelfde deel van
            // het tekenvlak, ongeacht vorm en maat van het kleed. De ijkmaat is een rond kleed
            // van 50 cm. De foto is niet naadloos, dus spiegelen in 2 x 2 en een tweede,
            // gedraaide laag eroverheen die het herhalingsritme breekt.
            // De foto is niet naadloos; we spiegelen hem in een blok van 2 x 2 zodat de randen
            // op elkaar aansluiten, en leggen er een gedraaide tweede laag overheen zodat de
            // spiegelas en de herhaling wegvallen.
            var deel = num(cfg.beeldSchaal, 44) / 100;
            if (!(deel > 0.05) || deel > 1.5) deel = 0.44;
            var tw = vak.w * deel;
            var th = tw * 0.75;
            var src = k.beeldGroot || k.beeld;
            var img = function (tf) {
              return '<image href="' + src + '" x="0" y="0" width="' + tw + '" height="' + th +
                '" preserveAspectRatio="xMidYMid slice"' + (tf ? ' transform="' + tf + '"' : "") + "/>";
            };
            var tegels = img(null) +
              img("translate(" + (tw * 2) + ",0) scale(-1,1)") +
              img("translate(0," + (th * 2) + ") scale(1,-1)") +
              img("translate(" + (tw * 2) + "," + (th * 2) + ") scale(-1,-1)");
            return '<pattern id="' + vulId + '" patternUnits="userSpaceOnUse" width="' + (tw * 2) + '" height="' + (th * 2) + '" x="' + x + '" y="' + y + '">' + tegels + "</pattern>" +
              '<pattern id="' + vulId2 + '" patternUnits="userSpaceOnUse" width="' + (tw * 2) + '" height="' + (th * 2) + '" x="' + x + '" y="' + y +
              '" patternTransform="rotate(38) scale(0.89)">' + tegels + "</pattern>";
          })()
        : '<pattern id="' + vulId + '" width="7" height="7" patternUnits="userSpaceOnUse">' +
          '<rect width="7" height="7" fill="' + tapijtHex() + '"/>' +
          '<path d="M0 3.5h7M3.5 0v7" stroke="rgba(255,255,255,.22)" stroke-width="1.4"/></pattern>';

      planSvg.innerHTML =
        "<defs>" + vulDef +
        '<pattern id="' + vulId + '-raster" width="' + stap + '" height="' + stap + '" patternUnits="userSpaceOnUse" x="' + x + '" y="' + y + '">' +
        '<path d="M0 0H' + stap + "M0 0V" + stap + '" stroke="currentColor" stroke-width=".7" opacity=".18" fill="none"/></pattern>' +
        '<marker id="' + pijlId + '" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">' +
        '<path d="M2 2 8 5 2 8z" fill="currentColor"/></marker>' +
        '<clipPath id="' + vulId + '-clip"><path transform="' + tf + '" d="' + d + '"/></clipPath>' +
        "</defs>" +
        '<g color="#9CA3AF">' +
        '<rect x="' + vak.x + '" y="' + vak.y + '" width="' + vak.w + '" height="' + vak.h + '" fill="url(#' + vulId + '-raster)"/>' +
        franjes +
        '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="url(#' + vulId + ')" clip-path="url(#' + vulId + '-clip)"/>' +
        (kbeeld
          ? '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="url(#' + vulId2 + ')" opacity=".45" clip-path="url(#' + vulId + '-clip)"/>'
          : "") +
        (bandCm && !franjeAan
          ? (function () {
              // De clip moet op een omhullende g staan: zet je hem op het pad zelf, dan wordt
              // de clipvorm mee-getransformeerd en valt de hele band weg.
              var lijn = function (kleur, breedte, extra) {
                return '<path transform="' + tf + '" d="' + d + '" fill="none" stroke="' + kleur +
                  '" stroke-width="' + breedte + '" vector-effect="non-scaling-stroke" stroke-linejoin="round"' +
                  (extra || "") + "/>";
              };
              var band = lijn("rgba(0,0,0,.35)", bandPx + 2, "") + lijn(rk, bandPx, "");
              band += lijn("rgba(0,0,0,.18)", bandPx, "");
              if (!gr || gr.soort === "feston") {
                band += lijn("rgba(255,255,255,.32)", bandPx - 2, ' stroke-dasharray="1 3"');
              }
              if (gr && gr.soort === "volume") {
                band += lijn("rgba(255,255,255,.30)", bandPx * 0.4, "");
              } else if (gr && gr.soort === "lint") {
                band += lijn("rgba(255,255,255,.7)", 1.4, ' stroke-dasharray="5 5"');
              }
              band += lijn("rgba(0,0,0,.25)", 1, "");
              return '<g clip-path="url(#' + vulId + '-clip)">' + band + "</g>";
            })()
          : "") +
        maatlijn(x, y + h + 36, x + w, y + h + 36, maatGetal(B) + " cm", true) +
        maatlijn(x - 28, y, x - 28, y + h, maatGetal(L) + " cm", false) +
        '<text x="' + vak.x + '" y="28" font-size="12" fill="currentColor" letter-spacing="1">' + titel.toUpperCase() + "</text>" +
        (s.modus === "kleed"
          ? '<text x="' + (vak.x + vak.w) + '" y="28" text-anchor="end" font-size="12" fill="currentColor">ROL ' + s.rolbreedte + " CM</text>"
          : "") +
        "</g>";
    }

    // Startkleur uit ?variant=: zo landt de klant vanaf de tweeling of een variantkaart op die kleur.
    try {
      var vkmVariant = new URLSearchParams(window.location.search).get("variant");
      if (vkmVariant) kleuren.forEach(function (k, i) { if (String(k.id) === vkmVariant) s.kleur = i; });
    } catch (e) { /* zonder URLSearchParams start de configurator op de eerste kleur */ }

    /* ---------- bouwstenen ---------- */
    function knop(titel, sub, actief, klik, ico) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "vkm-keuze";
      b.setAttribute("aria-pressed", actief ? "true" : "false");
      if (ico) {
        b.innerHTML = '<i><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ico + "</svg></i>";
      }
      var t1 = document.createElement("b"); t1.textContent = titel;
      var t2 = document.createElement("em"); t2.textContent = sub;
      b.appendChild(t1); b.appendChild(t2);
      b.addEventListener("click", klik);
      return b;
    }
    function swatch(label, beeld, hex, actief, klik, titelAttr) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "vkm-swatch";
      b.setAttribute("aria-pressed", actief ? "true" : "false");
      if (titelAttr) b.title = titelAttr;
      var i = document.createElement("i");
      if (beeld) i.style.backgroundImage = "url(" + beeld + ")";
      else if (hex) i.style.backgroundColor = hex;
      b.appendChild(i);
      if (label) { var sp = document.createElement("span"); sp.textContent = label; b.appendChild(sp); }
      b.addEventListener("click", klik);
      return b;
    }
    function tweelingKnop() {
      var tw = cfg.tweeling;
      var a = document.createElement("a");
      a.className = "vkm-keuze";
      var k = kleuren[s.kleur];
      var vid = k && tw.varianten ? tw.varianten[k.titel] : null;
      a.href = tw.url + (vid ? "?variant=" + vid : "");
      var meter = tw.modus === "meter";
      a.innerHTML = '<i><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (meter ? ICO_METER : ICO_KLEED) + "</svg></i>";
      var t1 = document.createElement("b"); t1.textContent = meter ? "Kamerbreed tapijt" : "Vloerkleed op maat";
      var t2 = document.createElement("em"); t2.textContent = meter ? "Per strekkende meter, van de rol" : "Afgewerkt, " + VORMEN.length + " vormen";
      a.appendChild(t1); a.appendChild(t2);
      return a;
    }
    function leeg(el) { while (el && el.firstChild) el.removeChild(el.firstChild); }
    function zetTekst(naam, waarde) {
      var el = root.querySelector('[data-vkm-toon="' + naam + '"]');
      if (el) el.textContent = waarde;
    }

    /* ---------- prijs ---------- */
    function bereken() {
      var regels = [], opp = 0, omtrek = 0, snijLabel = "";

      if (s.modus === "meter") {
        var m = meters();
        opp = m * (s.rolbreedte / 100);
        regels.push({ t: "Tapijt van de rol", sub: getal(m) + " m × " + getal(s.rolbreedte / 100) + " m = " + getal(opp) + " m²", p: opp * prijsM2() });
        snijLabel = getal(s.rolbreedte, 0) + " × " + getal(m * 100, 0) + " cm";
      } else if (s.modus === "trap") {
        var t = trapvormen[s.trapvorm] || { b: 56, d: 19, rond: true };
        var n = treden();
        var g1 = meetPad(t.rond ? TRAPPAD_ROND : TRAPPAD_RECHT, t.b, t.d);
        var oppM = g1 ? g1.opp : (t.b / 100) * (t.d / 100);
        var omtM = g1 ? g1.omtrek : 2 * ((t.b / 100) + (t.d / 100));
        var randPrijs = groepen.length ? groepen[0].breedtes[0].prijs : 0;
        opp = n * oppM; omtrek = n * omtM;
        regels.push({ t: "Tapijt, " + n + " matten", sub: getal(oppM, 3) + " m² per mat × " + euro(prijsM2()), p: opp * prijsM2() });
        regels.push({ t: "Rondom afwerken", sub: getal(omtrek) + " m rand × " + euro(randPrijs), p: omtrek * randPrijs });
        regels.push({ t: "Anti-slip rug", sub: "standaard op elke trapmat", p: opp * cfg.antislipM2 });
        regels.push({ t: "Confectie en snijden", sub: "eenmalig", p: cfg.confectie });
        snijLabel = t.b + " × " + t.d + " cm per mat";
      } else {
        var mm = maten(), v = vorm(), g = groep(), bb = randbreedte();
        opp = mm.opp; omtrek = mm.omtrek;
        var recht = (v.id === "rechthoek" || v.id === "vierkant");
        regels.push({
          t: "Tapijt " + (recht ? "op maat" : "uitgesneden"),
          // Afgerekend wordt wat er van de rol gaat, inclusief snijafval: strekkende meters
          // maal de prijs per strekkende meter van deze rol (= rolbreedte x m2-prijs).
          sub: (mm.baan
                  ? getal(mm.baan / 100) + " strekkende meter × " + euro(prijsM2() * s.rolbreedte / 100) +
                    " · rol " + getal(s.rolbreedte / 100, 0) + " m breed, incl. snijafval" + (marge() ? " en " + marge() + " cm snijmarge per kant" : "")
                  : getal(mm.snij) + " m² snijmaat × " + euro(prijsM2())) +
               (recht && !mm.baan ? "" : " · kleed zelf " + getal(mm.opp) + " m²"),
          p: mm.snij * prijsM2()
        });
        // Toeslagen op de afwerking, nooit op het tapijt. Per product (metavelden), twee regels:
        // - Montinique/Hebeta (mail 12-10-2026): toeslagPct op elke afwerking bij een kleed langer dan
        //   400 cm of vanaf 16 m2 (custom.toeslag_afwerking_pct).
        // - Belakos (mail 29-09-2026), Ambiant op dezelfde regel (Faruk 16-10): alleen op festonneren,
        //   + vormPct bij een andere vorm dan rond of rechthoek/vierkant, + grootPct als de lengte of
        //   de breedte boven 400 cm komt; samen opgeteld (custom.toeslag_feston_vorm_pct/_groot_pct).
        var toeslagPct = num(cfg.toeslagPct, 0);
        var grensM2 = num(cfg.toeslagVanafM2, 0), grensCm = num(cfg.toeslagVanafCm, 0);
        // Montinique: ook bij precies 400 cm (Faruk 20-10: "gewoon aanzetten"; prijslijst Hebeta 2026:
        // "vanaf een lengte/breedte van 400 cm"). De Belakos-regel hieronder blijft "groter dan 400".
        var groot = (grensM2 > 0 && mm.opp >= grensM2) || (grensCm > 0 && Math.max(mm.B, mm.L) >= grensCm);
        var pct = 0, redenen = [];
        if (groot && toeslagPct > 0) { pct += toeslagPct; redenen.push("grote maat"); }
        if (g.soort === "feston") {
          var fVorm = num(cfg.toeslagFestonVormPct, 0), fGroot = num(cfg.toeslagFestonGrootPct, 0);
          // Cube is een vierkant (met of zonder ronde hoeken) en valt onder de uitzondering (Faruk 20-10).
          if (fVorm > 0 && ["rechthoek", "vierkant", "cube", "rond"].indexOf(v.id) === -1) { pct += fVorm; redenen.push("vorm"); }
          if (fGroot > 0 && grensCm > 0 && Math.max(mm.B, mm.L) > grensCm) {
            pct += fGroot;
            if (redenen.indexOf("grote maat") === -1) redenen.push("grote maat");
          }
        }
        var randPrijs = bb.prijs * (1 + pct / 100);
        regels.push({
          t: g.naam + (g.breedtes.length > 1 && bb.naam ? ", " + String(bb.naam).toLowerCase() : ""),
          sub: getal(mm.omtrek) + " m rand × " + euro(randPrijs) +
               (pct > 0 ? " · incl. " + pct + "% toeslag " + redenen.join(" en ") : ""),
          p: mm.omtrek * randPrijs
        });
        if (g.antislipInbegrepen) {
          regels.push({ t: "Anti-slip onderkleed", sub: "zit bij deze afwerking inbegrepen", p: 0, gratis: true });
        } else if (s.antislip) {
          var asPrijs = num(cfg.antislip1M2, cfg.antislipM2);
          regels.push({
            t: "Anti-slip onderkleed 1 mm",
            sub: getal(mm.opp) + " m² × " + euro(asPrijs),
            p: mm.opp * asPrijs
          });
        }
        // snijkosten verschillen per vorm: recht, rond of een vrije vorm
        var soort = v.snij || "recht";
        var snijPrijs = num(soort === "rond" ? cfg.snijRond : soort === "speciaal" ? cfg.snijSpeciaal : cfg.snijRecht, cfg.confectie);
        regels.push({
          t: "Snijden en confectie",
          sub: soort === "rond" ? "rond karpet" : soort === "speciaal" ? "vrije vorm" : "rechthoekig karpet",
          p: snijPrijs
        });
        snijLabel = maatGetal(mm.B) + " × " + maatGetal(mm.L) + " cm";
      }

      var ruw = 0;
      regels.forEach(function (r) { ruw += r.p; });
      var eenheden = Math.max(1, Math.ceil(ruw / cfg.eenheidPrijs));
      var totaal = eenheden * cfg.eenheidPrijs;
      return { regels: regels, opp: opp, omtrek: omtrek, snij: snijLabel, ruw: ruw, eenheden: eenheden, totaal: totaal };
    }


    /* Sfeerfoto's van de gekozen kleur. Staat de kleurnaam in de alt-tekst van een foto,
       dan horen alleen die foto's bij die kleur. Zo niet, dan tonen we alle sfeerbeelden. */
    function sfeerVoorKleur() {
      var alle = cfg.sfeer || [];
      if (!alle.length) return [];
      var k = kleuren[s.kleur];
      if (!k) return alle;
      var naam = String(k.titel || "").toLowerCase().trim();
      if (!naam) return alle;
      var eigen = alle.filter(function (f) {
        return String(f.alt || "").toLowerCase().indexOf(naam) !== -1;
      });
      return eigen.length ? eigen : alle.filter(function (f) {
        // foto's die duidelijk bij een andere kleur horen, laten we weg
        for (var i = 0; i < kleuren.length; i++) {
          if (i === s.kleur) continue;
          var an = String(kleuren[i].titel || "").toLowerCase().trim();
          if (an && String(f.alt || "").toLowerCase().indexOf(an) !== -1) return false;
        }
        return true;
      });
    }

    /* ---------- tekenen ---------- */
    function teken() {
      // Een rolbreedte die bij deze kleur niet bestaat (na een kleurwissel) gaat naar de eerste die wel bestaat.
      if (rollen().indexOf(Number(s.rolbreedte)) === -1) s.rolbreedte = rollen()[0];
      kiesRol();
      var v = vorm(), g = groep();

      root.querySelectorAll("[data-vkm-modus-blok]").forEach(function (el) {
        el.hidden = el.getAttribute("data-vkm-modus-blok") !== s.modus;
      });

      var mv = root.querySelector("[data-vkm-maatvelden]");
      if (mv) {
        var toon = function (naam, aan) {
          var el = mv.querySelector('[data-vkm-veld="' + naam + '"]');
          if (el) el.hidden = !aan;
        };
        var tweeMaten = (v.invoer !== "diameter");
        toon("lengte", tweeMaten);
        toon("breedte", tweeMaten);
        toon("maal", tweeMaten);
        toon("diameter", v.invoer === "diameter");
        toon("radius", heeftRadius(v));
        var radiusIn = mv.querySelector('[data-vkm-in="radius"]');
        if (radiusIn && heeftRadius(v)) {
          radiusIn.max = Math.floor(radiusMax(v));
          if (document.activeElement !== radiusIn) radiusIn.value = Math.round(hoekradius(v));
        }
        var gelijk = root.querySelector("[data-vkm-gelijk]");
        if (gelijk) gelijk.hidden = (v.invoer === "diameter") || !!v.vrij;
      }

      /* kleuren */
      var kh = root.querySelector("[data-vkm-kleuren]");
      if (kh) {
        leeg(kh);
        kleuren.forEach(function (k, i) {
          kh.appendChild(swatch(k.titel, k.beeld, null, i === s.kleur, function () { s.kleur = i; teken(); meldKleur(); }, k.titel));
        });
      }

      /* modus */
      var mh = root.querySelector("[data-vkm-modus]");
      if (mh) {
        leeg(mh);
        MODI.forEach(function (o) {
          mh.appendChild(knop(o.naam, o.sub, s.modus === o.id, function () { s.modus = o.id; teken(); }, o.ico));
        });
        // "Kies hoe je wilt bestellen" is geen keuze meer (Faruk 19-10): kleed en tapijt zijn aparte
        // producten met een eigen configurator. Geen tweeling-knop; bij één bestelwijze vervalt de stap.
      }
      var modusStap = root.querySelector('[data-vkm-stap="modus"]');
      if (modusStap) modusStap.hidden = MODI.length <= 1;

      /* rolbreedte bij meter */
      var rh = root.querySelector("[data-vkm-rolbreedte-meter]");
      if (rh) {
        leeg(rh);
        var rl = rollen();
        // Eén rolbreedte: niets te kiezen, dus geen knop maar een mededeling. De stapsgewijze laag
        // ziet data-vkm-een-rol en telt de stap dan als gedaan.
        root.toggleAttribute("data-vkm-een-rol", rl.length === 1);
        var rolkop = root.querySelector("[data-vkm-rolkop]");
        if (rolkop) rolkop.textContent = rl.length === 1 ? "Rolbreedte" : "Kies de rolbreedte";
        if (rl.length === 1) {
          var ri = document.createElement("p");
          ri.className = "vkm-rolinfo";
          ri.appendChild(document.createTextNode("Deze kwaliteit is alleen leverbaar op een rol van "));
          var rib = document.createElement("b");
          rib.textContent = getal(rl[0] / 100, 0) + " meter breed";
          ri.appendChild(rib);
          ri.appendChild(document.createTextNode(": " + euro(prijsM2() * rl[0] / 100) + " per strekkende meter."));
          rh.appendChild(ri);
        } else {
          rl.forEach(function (b) {
            rh.appendChild(knop(b / 100 + " meter breed", euro(prijsM2() * b / 100) + " per strekkende meter",
              s.rolbreedte === b, function () { s.rolbreedte = b; teken(); }));
          });
        }
      }

      /* vormen */
      var vh = root.querySelector("[data-vkm-vormen]");
      if (vh) {
        leeg(vh);
        VORMEN.forEach(function (o) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "vkm-vorm";
          b.setAttribute("aria-pressed", o.id === s.vorm ? "true" : "false");
    // vaste weergaveverhouding per vorm: de tegels blijven staan, ook als je de maten wijzigt.
    // Alleen de tapijtvulling wisselt mee met de gekozen kleur.
    var ico = o.icoon || [90, 100];
    var iB = ico[0], iL = ico[1];
    var isc = Math.min(100 / iB, 100 / iL);
    var iw = iB * isc, ih = iL * isc;
    var ix = (100 - iw) / 2, iy = (100 - ih) / 2;
    var itf = "translate(" + ix + "," + iy + ") scale(" + (iw / 100) + "," + (ih / 100) + ")";
    var kv = kleuren[s.kleur];
    var tex = kv && (kv.beeldGroot || kv.beeld);
    var clipId = "vkm-vc-" + (root.getAttribute("data-section-id") || "x") + "-" + o.id;
    var od = tegelPad(o);
    var vlak = tex
      ? '<defs><clipPath id="' + clipId + '"><path transform="' + itf + '" d="' + od + '"/></clipPath></defs>' +
        '<image href="' + tex + '" x="' + ix + '" y="' + iy + '" width="' + iw + '" height="' + ih +
        '" preserveAspectRatio="xMidYMid slice" clip-path="url(#' + clipId + ')"/>' +
        '<path transform="' + itf + '" d="' + od + '" fill="none" stroke="rgba(0,0,0,.35)" stroke-width="1.4" vector-effect="non-scaling-stroke"/>'
      : '<path transform="' + itf + '" d="' + od + '" fill="currentColor" fill-opacity=".17" stroke="currentColor" stroke-width="1.6" vector-effect="non-scaling-stroke"/>';
    b.innerHTML = '<svg width="66" height="66" viewBox="-5 -5 110 110" fill="none" stroke="currentColor" stroke-linejoin="round" aria-hidden="true">'
      + vlak + "</svg>"
      + "<b>" + o.naam + "</b><em>"
      + (o.invoer === "diameter" ? "diameter" : o.invoer === "zijde" ? "1 maat" : "l \u00d7 b") + "</em>";
    b.addEventListener("click", function () {
      var mm0 = maten(), grootte = Math.max(mm0.B, mm0.L);
      s.vorm = o.id;
      if (o.vrij) { zetVormMaat("breedte", mm0.B); zetVormMaat("lengte", mm0.L); }
      else zetVormMaat(o.icoon[0] >= o.icoon[1] ? "breedte" : "lengte", grootte);
      teken();
    });
    vh.appendChild(b);
        });
        var vu = root.querySelector("[data-vkm-vorm-uitleg]");
        if (vu) { vu.textContent = v.uitleg || ""; vu.hidden = !v.uitleg; }
      }

      /* maatknoppen */
      var mk = root.querySelector("[data-vkm-maatknoppen]");
      if (mk) {
        leeg(mk);
        var zet = function (label, fn, actief) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "vkm-maatknop";
          b.textContent = label;
          b.setAttribute("aria-pressed", actief ? "true" : "false");
          b.addEventListener("click", function () { fn(); teken(); });
          mk.appendChild(b);
        };
        if (v.invoer === "lb" && v.vrij) {
          MAAT_RECHT.forEach(function (bl) {
            zet(bl[1] + " × " + bl[0] + " cm", function () {
              zetVormMaat("breedte", bl[0]);
              zetVormMaat("lengte", bl[1]);
            }, s.breedte === bl[0] && s.lengte === bl[1]);
          });
        } else if (v.invoer === "lb") {
          MAAT_LB.forEach(function (grootte) {
            var as = v.icoon[0] >= v.icoon[1] ? "breedte" : "lengte";
            var m = vasteVormMaten(v, as, grootte, cfg.minMaat);
            if (!m) return;
            // Zelfde afronding op 5 cm als zetVormMaat, anders toont de knop 296 × 400 en kiest hij 300 × 400.
            zet(maatGetal(op5(m.L)) + " × " + maatGetal(op5(m.B)) + " cm", function () {
              zetVormMaat(as, grootte);
            }, s.lengte === op5(m.L) && s.breedte === op5(m.B));
          });
        } else if (v.invoer === "diameter") {
          MAAT_ENKEL.forEach(function (m) {
            zet(m + " cm", function () { zetVormMaat("diameter", m); }, s.diameter === m);
          });
        } else {
          MAAT_ENKEL.forEach(function (m) {
            zet(m + " cm", function () { zetVormMaat("breedte", m); }, s.breedte === m && s.lengte === m);
          });
        }
      }

      /* randafwerking */
      var ah = root.querySelector("[data-vkm-randen]");
      if (ah) {
        leeg(ah);
        groepen.forEach(function (o) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "vkm-randtegel";
          b.setAttribute("aria-pressed", o.sleutel === s.groep ? "true" : "false");
          var laagste = o.breedtes[0].prijs;
          o.breedtes.forEach(function (x) { if (x.prijs < laagste) laagste = x.prijs; });
          var prijsTekst = o.breedtes.length > 1
            ? "vanaf " + euro(laagste) + " per meter"
            : euro(o.breedtes[0].prijs) + " per meter";
          b.innerHTML = (o.foto
            ? '<img src="' + o.foto + '" alt="' + o.naam + '" loading="lazy">'
            : hoekTekening(o)) + "<b>" + o.naam + "</b><em>" + prijsTekst + "</em>";
          b.addEventListener("click", function () {
            s.groep = o.sleutel;
            var heeft = false;
            o.breedtes.forEach(function (x) { if (x.id === s.randbreedte) heeft = true; });
            if (!heeft) s.randbreedte = o.breedtes[0].id;
            teken();
          });
          ah.appendChild(b);
        });
        var ru = root.querySelector("[data-vkm-rand-uitleg]");
        if (ru) { ru.textContent = g ? g.uitleg : ""; ru.hidden = !(g && g.uitleg); }
      }

      /* randbreedte */
      var bh = root.querySelector("[data-vkm-randbreedtes]");
      var bstap = root.querySelector("[data-vkm-breedtestap]");
      if (bh && g) {
        leeg(bh);
        g.breedtes.forEach(function (bb) {
          bh.appendChild(knop(bb.naam, ((bb.sub && bb.sub !== bb.naam) ? bb.sub + " · " : "") + euro(bb.prijs) + "/m",
            s.randbreedte === bb.id, function () { s.randbreedte = bb.id; teken(); }));
        });
        if (bstap) bstap.hidden = g.breedtes.length < 2;
      }

      var kiesKleur = (cfg.toonRandkleur !== false);
      [["[data-vkm-randkleurstap]"], ["[data-vkm-randkleurstap-trap]"]].forEach(function (sel) {
        var el = root.querySelector(sel[0]);
        if (el) el.hidden = !kiesKleur;
      });

      /* randkleuren */
      [["[data-vkm-randkleuren]", "randkleur"], ["[data-vkm-randkleuren-trap]", "randkleur-trap"]].forEach(function (paar) {
        var h = root.querySelector(paar[0]);
        if (!h) return;
        leeg(h);
        randkleuren.forEach(function (k, i) {
          h.appendChild(swatch(k.naam, null, k.hex, i === s.randkleur, function () { s.randkleur = i; teken(); },
            k.naam + (k.nr ? " (" + k.nr + ")" : "")));
        });
      });

      /* trapvormen */
      var th = root.querySelector("[data-vkm-trapvormen]");
      if (th) {
        leeg(th);
        trapvormen.forEach(function (t, i) {
          var g1 = meetPad(t.rond ? TRAPPAD_ROND : TRAPPAD_RECHT, t.b, t.d);
          var oppM = g1 ? g1.opp : (t.b / 100) * (t.d / 100);
          var omtM = g1 ? g1.omtrek : 2 * ((t.b / 100) + (t.d / 100));
          var randPrijs = groepen.length ? groepen[0].breedtes[0].prijs : 0;
          var per = oppM * prijsM2() + omtM * randPrijs + oppM * cfg.antislipM2;
          th.appendChild(knop(t.naam + " " + t.b + " × " + t.d + " cm", euro(per) + " per mat",
            s.trapvorm === i, function () { s.trapvorm = i; teken(); }));
        });
      }

      /* anti-slip */
      /* Anti-slip is altijd 1 mm: geen diktekeuze meer, alleen aan of uit. */
      var dikteBlok = root.querySelector("[data-vkm-antislipdikte]");
      if (dikteBlok) { leeg(dikteBlok); dikteBlok.hidden = true; }
      var asBlok = root.querySelector("[data-vkm-antislipblok]");
      if (asBlok) {
        var vast = !!(g && g.antislipInbegrepen);
        var vink = asBlok.querySelector("input");
        vink.checked = vast ? true : s.antislip;
        vink.disabled = vast;
        asBlok.setAttribute("data-aan", (vast || s.antislip) ? "1" : "0");
        var ap = root.querySelector("[data-vkm-antislip-prijs]");
        if (ap) ap.textContent = vast ? "inbegrepen" : "";
        var au = root.querySelector("[data-vkm-antislip-uitleg]");
        if (au) {
          au.textContent = vast
            ? "Bij deze afwerking zit een anti-slip onderkleed standaard inbegrepen."
            : "Zorgt dat je kleed niet verschuift. Aanrader op laminaat, pvc en tegels.";
        }
      }

      tekenPlan();

      /* galerij: schaaltekening plus de sfeerfoto's van deze kleur */
      var sfeer = sfeerVoorKleur();
      if (s.beeld > sfeer.length) s.beeld = 0;
      var th = root.querySelector("[data-vkm-thumbs]");
      var plan = root.querySelector("[data-vkm-plan]");
      var foto = root.querySelector("[data-vkm-sfeer]");
      if (th) {
        th.hidden = !sfeer.length;
        leeg(th);
        if (sfeer.length) {
          var maakThumb = function (index, inhoud, titel) {
            var b = document.createElement("button");
            b.type = "button";
            b.className = "vkm-thumb";
            b.title = titel;
            b.setAttribute("aria-pressed", s.beeld === index ? "true" : "false");
            b.innerHTML = inhoud;
            b.addEventListener("click", function () { s.beeld = index; teken(); });
            th.appendChild(b);
          };
          maakThumb(0,
            '<svg viewBox="0 0 72 56" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
            '<rect x="14" y="10" width="44" height="36" rx="2"/><path d="M8 28h4M60 28h4M36 4v4M36 48v4"/></svg>',
            "Schaaltekening");
          sfeer.slice(0, 7).forEach(function (f, i) {
            var img = document.createElement("img");
            img.src = f.klein; img.alt = f.alt || "";
            maakThumb(i + 1, "", f.alt || "Sfeerfoto");
            th.lastChild.appendChild(img);
          });
        }
      }
      var toonFoto = (s.beeld > 0 && sfeer[s.beeld - 1]);
      if (plan) plan.hidden = !!toonFoto;
      if (foto) {
        if (toonFoto) {
          foto.src = sfeer[s.beeld - 1].groot;
          foto.alt = sfeer[s.beeld - 1].alt || "";
          foto.hidden = false;
        } else {
          foto.hidden = true;
        }
      }

      var k = kleuren[s.kleur] || { titel: "" };
      var bb2 = randbreedte();
      var rk = randkleuren[s.randkleur] || { naam: "", nr: "" };
      var tv = trapvormen[s.trapvorm] || { naam: "", b: 0, d: 0 };
      zetTekst("kleur", k.titel);
      zetTekst("vorm", v.naam);
      zetTekst("afwerking", g ? g.naam : "");
      zetTekst("randbreedte", bb2 ? bb2.naam : "");
      zetTekst("randkleur", rk.naam);
      zetTekst("randkleur-trap", rk.naam);
      zetTekst("trapvorm", tv.naam + " " + tv.b + " × " + tv.d + " cm");
      zetTekst("rolbreedte-m", getal(s.rolbreedte / 100));
      zetTekst("meter-m2", getal(meters() * s.rolbreedte / 100));
      zetTekst("rolbreedte-kleed", String(s.rolbreedte));
      zetTekst("maxkleed", String(bruikbaar(Math.max.apply(null, rollen()), marge())));

      var b = bereken();
      var opp = root.querySelector("[data-vkm-opp]");
      var omt = root.querySelector("[data-vkm-omtrek]");
      var snij = root.querySelector("[data-vkm-snij]");
      if (opp) opp.textContent = getal(b.opp) + " m²";
      if (omt) omt.textContent = b.omtrek ? getal(b.omtrek) + " m" : "–";
      if (snij) snij.textContent = b.snij;

      /* samenvatting */
      var mini = root.querySelector("[data-vkm-mini]");
      if (mini) {
        leeg(mini);
        var gekozenIcoon = root.querySelector('[data-vkm-vormen] [aria-pressed="true"] svg');
        if (s.modus === "kleed" && gekozenIcoon) {
          // Hergebruik de vormtegel, zodat vorm en tapijtkleur samen blijven wisselen.
          var miniSvg = gekozenIcoon.cloneNode(true);
          miniSvg.setAttribute("width", "100%");
          miniSvg.setAttribute("height", "100%");
          var miniClip = miniSvg.querySelector("clipPath");
          if (miniClip) {
            miniClip.id += "-samenvatting";
            miniSvg.querySelector("[clip-path]").setAttribute("clip-path", "url(#" + miniClip.id + ")");
          }
          mini.style.background = "#fff";
          mini.style.border = "0";
          mini.appendChild(miniSvg);
        } else {
          mini.style.border = "";
          mini.style.background = tapijtHex();
          if (k.beeld) mini.style.backgroundImage = "url(" + k.beeld + ")";
        }
      }
      /* fotovoorbeeld: hetzelfde kleed, plat op de vloertegel naast "Zie dit kleed in je eigen ruimte" */
      var ruimteVorm = root.querySelector("[data-vkm-ruimte-vorm]");
      var ruimteBron = root.querySelector('[data-vkm-vormen] [aria-pressed="true"] svg');
      if (ruimteVorm && s.modus === "meter") {
        // Kamerbreed: geen kleed op de vloer maar de vloer zelf, dus het materiaal over de hele tegel.
        leeg(ruimteVorm);
        ruimteVorm.style.backgroundImage = k.beeld ? "url(" + k.beeld + ")" : "";
        ruimteVorm.style.backgroundSize = "cover";
      } else if (ruimteVorm && ruimteBron) {
        ruimteVorm.style.backgroundImage = "";
        var ruimteSvg = ruimteBron.cloneNode(true);
        var ruimteClip = ruimteSvg.querySelector("clipPath");
        if (ruimteClip) {
          ruimteClip.id += "-ruimte";
          ruimteSvg.querySelector("[clip-path]").setAttribute("clip-path", "url(#" + ruimteClip.id + ")");
        }
        leeg(ruimteVorm);
        ruimteVorm.appendChild(ruimteSvg);
      }
      var svT = root.querySelector("[data-vkm-sv-titel]");
      var lijst = root.querySelector("[data-vkm-sv-lijst]");
      if (svT && lijst) {
        leeg(lijst);
        var rij = function (dt, dd) {
          var a = document.createElement("dt"); a.textContent = dt;
          var c = document.createElement("dd"); c.textContent = dd;
          lijst.appendChild(a); lijst.appendChild(c);
        };
        if (s.modus === "meter") {
          svT.textContent = cfg.productTitel + " per strekkende meter";
          rij("Kleur", k.titel);
          rij("Breedte", getal(s.rolbreedte / 100) + " meter");
          rij("Strekkende meters", getal(meters()) + " m");
          rij("Afwerking", "onafgewerkt, van de rol");
        } else if (s.modus === "trap") {
          svT.textContent = "Trapmatten op maat " + cfg.productTitel;
          rij("Kleur", k.titel);
          rij("Vorm", tv.naam + " " + tv.b + " × " + tv.d + " cm");
          rij("Aantal", treden() + " stuks");
          rij("Afwerkkleur", rk.naam + (rk.nr ? " (" + rk.nr + ")" : ""));
        } else {
          svT.textContent = "Vloerkleed op maat " + cfg.productTitel;
          rij("Kleur", k.titel);
          rij("Vorm", vormNaamMaat(v));
          rij("Afmeting", b.snij);
          rij("Randafwerking", (g ? g.naam : "") + (bb2 && bb2.sub ? ", " + bb2.sub : ""));
          rij("Afwerkkleur", kiesKleur ? rk.naam + (rk.nr ? " (" + rk.nr + ")" : "") : "Bijpassend gematched");
          rij("Anti-slip", ((g && g.antislipInbegrepen) || s.antislip) ? "ja" : "nee");
        }
      }

      /* prijsregels */
      var rg = root.querySelector("[data-vkm-regels]");
      if (rg) {
        leeg(rg);
        b.regels.forEach(function (r) {
          var d = document.createElement("div");
          d.className = "vkm-regel" + (r.gratis ? " vkm-gratis" : "");
          var links = document.createElement("span");
          var t1 = document.createElement("span"); t1.textContent = r.t;
          var t2 = document.createElement("em"); t2.textContent = r.sub;
          links.appendChild(t1); links.appendChild(t2);
          var bed = document.createElement("b");
          bed.textContent = r.gratis ? "inbegrepen" : euro(r.p);
          d.appendChild(links); d.appendChild(bed);
          rg.appendChild(d);
        });
        if (b.totaal - b.ruw > 0.004) {
          var afr = document.createElement("div");
          afr.className = "vkm-regel";
          var l2 = document.createElement("span");
          var a1 = document.createElement("span"); a1.textContent = "Afronding";
          var a2 = document.createElement("em"); a2.textContent = "naar boven op hele euro's";
          l2.appendChild(a1); l2.appendChild(a2);
          var b2 = document.createElement("b"); b2.textContent = euro(b.totaal - b.ruw);
          afr.appendChild(l2); afr.appendChild(b2);
          rg.appendChild(afr);
        }
      }
      // Kop zoals de vloer-PDP, voor de gekozen kleur. Prijs altijd per m2, gelijk aan variantprijs
      // en feed (Google vergelijkt die); de strekkende meter van de rol telt alleen mee in de prijsregels.
      // Adviesprijs en kortingsvaan erbij (de feed stuurt de adviesprijs mee), en de SKU van de kleur.
      var kpPrijs = prijsM2(), kpAdvies = adviesM2();
      var kpKorting = kpAdvies > kpPrijs ? Math.round((kpAdvies - kpPrijs) / kpAdvies * 100) : 0;
      var kpSku = (kleuren[s.kleur] && kleuren[s.kleur].sku) || "";
      kopZet("[data-vkm-kopprijs]", geld(kpPrijs));
      kopZet("[data-vkm-kopadvies-bedrag]", geld(kpAdvies), kpKorting > 0, "[data-vkm-kopadvies]");
      kopZet("[data-vkm-korting-pct]", kpKorting + "%", kpKorting > 0, "[data-vkm-korting]");
      kopZet("[data-vkm-sku]", kpSku, kpSku !== "", "[data-vkm-sku-regel]");
      // Prijsregels gelden per kleed; het totaal is maal het aantal kleden.
      var n = stuks();
      var pr = root.querySelector("[data-vkm-prijs]");
      if (pr) pr.textContent = euro(b.totaal * n);
      var ts = root.querySelector("[data-vkm-totaal-sub]");
      // Van de rol is onafgewerkt: daar zit geen confectie in.
      if (ts) ts.textContent = (n > 1 ? n + " × " + euro(b.totaal) + ", " : "") + (s.modus === "meter" ? "incl. btw" : "incl. btw en confectie");
      var sb = root.querySelector("[data-vkm-stuks-blok]");
      if (sb) {
        sb.hidden = !heeftStuks();
        var si = sb.querySelector("[data-vkm-stuks]");
        if (si && document.activeElement !== si) si.value = n;
        var smin = sb.querySelector("[data-vkm-stuks-min]");
        var splus = sb.querySelector("[data-vkm-stuks-plus]");
        if (smin) smin.disabled = n <= 1;
        if (splus) splus.disabled = n >= MAX_STUKS;
      }

      var lt = root.querySelector("[data-vkm-levertijd]");
      if (lt) lt.textContent = s.modus === "meter" ? cfg.levertijdRol : cfg.levertijdMaatwerk;

      var pm = root.querySelector("[data-vkm-permat]");
      if (pm) {
        if (s.modus === "trap" && trapvormen.length) {
          var g2 = meetPad(tv.rond ? TRAPPAD_ROND : TRAPPAD_RECHT, tv.b, tv.d);
          var oppM2 = g2 ? g2.opp : (tv.b / 100) * (tv.d / 100);
          var omtM2 = g2 ? g2.omtrek : 2 * ((tv.b / 100) + (tv.d / 100));
          var rp = groepen.length ? groepen[0].breedtes[0].prijs : 0;
          pm.textContent = "× " + euro(oppM2 * prijsM2() + omtM2 * rp + oppM2 * cfg.antislipM2) + " per mat";
        } else { pm.textContent = ""; }
      }

      /* rekenhulp */
      var rhk = root.querySelector("[data-vkm-rekenhulp]");
      if (rhk) {
        var kl = Math.max(0, s.kamerL), kb = Math.max(0, s.kamerB), rol = s.rolbreedte / 100;
        leeg(rhk);
        if (kl > 0 && kb > 0) {
          // Banen van de rol naast elkaar: de rolbreedte bepaalt waar de naad komt (Faruk 16-10,
          // er is geen rol breder dan 5 m). Beide legrichtingen proberen, de kortste totale lengte
          // wint. Rekenen in hele eenheden van 5 cm, dan rondt meters() niet nog eens op.
          // Pasmarge van 10 cm langs elke muur, dus ook in de breedte (Faruk 16-10).
          var pasmarge = 2 * SNIJMARGE / 100;
          var plan = [[kb, kl], [kl, kb]].map(function (r) {
            var banen = Math.max(1, Math.ceil((r[0] + pasmarge) / rol - 1e-9));
            var baan = Math.ceil((r[1] + pasmarge) * 20 - 1e-9);
            return { banen: banen, baan: baan / 20, nodig: banen * baan / 20 };
          }).sort(function (a, b) { return a.nodig - b.nodig; })[0];
          var nodig = plan.nodig;
          var uitkomst = document.createElement("span");
          var nodigB = document.createElement("b");
          nodigB.textContent = getal(nodig) + " strekkende meter";
          uitkomst.appendChild(document.createTextNode("Oppervlakte kamer " + getal(kl * kb) + " m². Op een rol van " +
            getal(rol) + " m breed heb je "));
          uitkomst.appendChild(nodigB);
          uitkomst.appendChild(document.createTextNode(plan.banen > 1
            ? " nodig: " + plan.banen + " banen van " + getal(plan.baan) + " m, inclusief " + SNIJMARGE + " cm pasmarge aan beide kanten."
            : " nodig, inclusief " + SNIJMARGE + " cm pasmarge aan beide kanten."));
          rhk.appendChild(uitkomst);
          var ov = document.createElement("button");
          ov.type = "button"; ov.className = "vkm-neemover"; ov.textContent = "Neem " + getal(nodig) + " m over";
          ov.addEventListener("click", function () { s.meters = nodig; zetInvoer("meters", nodig); teken(); });
          rhk.appendChild(ov);
        } else {
          rhk.textContent = "Vul beide maten in.";
        }
      }

      /* meldingen */
      var mm2 = root.querySelector("[data-vkm-maatmelding]");
      if (mm2) {
        mm2.innerHTML = "";
        if (s.modus === "kleed") {
          var mt = maten();
          var fout = kleedTeGroot();
          if (fout) {
            mm2.innerHTML = '<div class="vkm-waarschuwing" role="alert">' + fout + "</div>";
          } else if (mt.B > bruikbaar(s.rolbreedte, marge())) {
            mm2.innerHTML = '<div class="vkm-letop">We leggen je kleed een kwartslag gedraaid op de rol, de ' + mt.B +
              " cm loopt dan mee in de lengte van de baan. Dat kan prima, let alleen op de lichtinval: de pool ligt dan de andere kant op.</div>";
          }
          if (!cfg.snijverliesDoorbelasten) {
            var rest = (s.rolbreedte / 100) * (mt.L / 100) - mt.snij;
            if (rest > 1.5 && mt.B <= bruikbaar(s.rolbreedte, marge())) {
              mm2.innerHTML += '<div class="vkm-letop">Naast dit kleed blijft ' + getal(rest) +
                " m² van de baan over. Daar maken we graag trapmatten of een loper van, vraag er even naar.</div>";
            }
          }
        }
      }
      // Zelfde fout bij de bestelknop, en weer weg zodra de maat past. Geen prijs tonen voor
      // een kleed dat niet te maken is (Faruk 16-10); de CSS verbergt regels en totaal.
      var groot = kleedTeGroot();
      root.toggleAttribute("data-vkm-te-groot", !!groot);
      if (foutEl) {
        if (groot) { toonFout(groot); foutEl.setAttribute("data-vkm-te-groot", ""); }
        else if (foutEl.hasAttribute("data-vkm-te-groot")) { toonFout(""); foutEl.removeAttribute("data-vkm-te-groot"); }
      }
      var tm = root.querySelector("[data-vkm-trapmelding]");
      if (tm) {
        tm.innerHTML = s.treden < cfg.minTrapmatten
          ? '<div class="vkm-letop">Het minimum is ' + cfg.minTrapmatten + " trapmatten, we rekenen met " + cfg.minTrapmatten + ".</div>"
          : "";
      }
      var af = root.querySelector("[data-vkm-afsluit]");
      if (af) {
        af.innerHTML = (s.modus !== "meter" && cfg.retourmelding)
          ? '<div class="vkm-letop">' + cfg.retourmelding + "</div>"
          : "";
      }
      if (ruimte) ruimte.update();
    }

    /* ---------- fotovoorbeeld ---------- */
    var ruimte = null;
    function ruimteKeuze() {
      // Strekkende meter = kamerbreed: de backend legt het tapijt over de hele vloer
      // (soort "kamerbreed"); vorm, maat en rand doen daar niet mee. Trapmatten: geen voorbeeld.
      if (s.modus === "meter") {
        var kt = kleuren[s.kleur] || {};
        return { soort: "kamerbreed", productHandle: cfg.productHandle, variantId: kt.id, product: cfg.productTitel,
          kleur: kt.titel || "", foto: (kt.beeldGroot || kt.beeld) ? new URL(kt.beeldGroot || kt.beeld, window.location.href).href : "" };
      }
      if (s.modus !== "kleed") return null;
      var k = kleuren[s.kleur] || {}, g = groep() || {}, r = randbreedte(), m = maten(), v = vorm();
      return {
        productHandle: cfg.productHandle, variantId: k.id, product: cfg.productTitel,
        kleur: k.titel || "", foto: (k.beeldGroot || k.beeld) ? new URL(k.beeldGroot || k.beeld, window.location.href).href : "", vorm: v.id, vormNaam: vormNaamMaat(v),
        breedte: m.B, lengte: m.L, afwerking: g.naam || "", afwerkingSoort: g.soort || "feston",
        // Blind banderen bestaat in katoen, leer en suede; dat materiaal staat in de breedtekeuze.
        afwerkingSub: r.sub || "",
        randbreedte: r.cm, randkleur: randHex(),
        antislip: !!(g.antislipInbegrepen || s.antislip), antislipDikte: s.antislipDikte,
        // Rechthoek en cube: de ingevulde hoekradius, zodat de impressie dezelfde hoeken krijgt.
        radius: heeftRadius(v) ? Math.round(hoekradius(v)) : null
      };
    }

    /* ---------- invoer ---------- */
    function zetInvoer(naam, waarde) {
      var el = root.querySelector('[data-vkm-in="' + naam + '"]');
      if (el) el.value = waarde;
    }
    function zetVormMaat(naam, waarde, actieveInvoer) {
      var v = vorm();
      if (v.vrij) {
        // Vrije vorm: alleen de ingevulde maat verandert, binnen dezelfde grenzen als de invoervelden.
        if (!Number.isFinite(waarde)) return;
        var minV = Math.max(50, num(cfg.minMaat, 50));
        if (naam === "lengte") s.lengte = op5(Math.min(2500, Math.max(minV, waarde)));
        else if (naam === "breedte" || naam === "diameter") s.breedte = op5(Math.min(500, Math.max(minV, waarde)));
        else return;
        s.diameter = s.breedte;
        ["lengte", "breedte", "diameter"].forEach(function (as) {
          var el = root.querySelector('[data-vkm-in="' + as + '"]');
          if (!el) return;
          el.min = op5(minV);
          el.max = as === "lengte" ? 2500 : 500;
          el.step = 5;
          if (as !== actieveInvoer) zetInvoer(as, Number(s[as].toFixed(2)));
        });
        return;
      }
      var m = vasteVormMaten(v, naam, waarde, cfg.minMaat);
      if (!m) return;
      // Ook de maat die bij een vaste vorm meeloopt gaat naar boven op 5 cm.
      s.breedte = op5(m.B);
      s.lengte = op5(m.L);
      s.diameter = s.breedte;
      var kleinste = vasteVormMaten(v, "breedte", 0, cfg.minMaat);
      var grootste = vasteVormMaten(v, "breedte", Number.MAX_VALUE, cfg.minMaat);
      ["lengte", "breedte", "diameter"].forEach(function (as) {
        var el = root.querySelector('[data-vkm-in="' + as + '"]');
        if (!el) return;
        var key = as === "lengte" ? "L" : "B";
        el.min = op5(kleinste[key]);
        el.max = Math.floor(grootste[key] / 5 + 1e-9) * 5;
        el.step = 5;
        if (as !== actieveInvoer) zetInvoer(as, Number(s[as].toFixed(2)));
      });
    }
    var grenzen = {
      lengte: [50, 2500], breedte: [50, 500], diameter: [50, 500], radius: [0, 250],
      meters: [1, 40], treden: [1, 40], kamerL: [0, 40], kamerB: [0, 40]
    };
    root.querySelectorAll("[data-vkm-in]").forEach(function (el) {
      var naam = el.getAttribute("data-vkm-in");
      if (naam === "rolbreedte") {
        el.addEventListener("change", function () { s.rolbreedte = num(el.value, s.rolbreedte); teken(); });
        return;
      }
      if (naam === "antislip") {
        el.addEventListener("change", function () { s.antislip = el.checked; teken(); });
        return;
      }
      var g = grenzen[naam];
      if (!g) return;
      var min = Math.max(g[0], naam === "lengte" || naam === "breedte" || naam === "diameter" || naam === "zijde" ? cfg.minMaat : g[0]);
      el.addEventListener("input", function () {
        var w = num(el.value, NaN);
        if (!Number.isFinite(w)) return;
        if (naam === "lengte" || naam === "breedte" || naam === "diameter") {
          zetVormMaat(naam, w, naam);
        } else if (naam === "radius") {
          var vr = vorm();
          if (heeftRadius(vr)) s.radius[vr.id] = Math.min(radiusMax(vr), Math.max(min, w));
        } else {
          s[naam] = Math.min(g[1], Math.max(min, w));
        }
        teken();
      });
      el.addEventListener("blur", function () {
        // Strekkende meters: het veld toont na het typen de afgeronde maat (5,32 wordt 5,35), zoals meters() rekent.
        if (naam === "meters") s.meters = meters();
        if (naam !== "radius") el.value = Number(s[naam].toFixed(2));
        else if (heeftRadius(vorm())) el.value = Math.round(hoekradius(vorm()));
      });
    });

    /* ---------- aantal kleden ---------- */
    (function () {
      var sb = root.querySelector("[data-vkm-stuks-blok]");
      if (!sb) return;
      var si = sb.querySelector("[data-vkm-stuks]");
      var zet = function (w) { s.stuks = Math.min(MAX_STUKS, Math.max(1, Math.round(w) || 1)); teken(); };
      var smin = sb.querySelector("[data-vkm-stuks-min]");
      var splus = sb.querySelector("[data-vkm-stuks-plus]");
      if (smin) smin.addEventListener("click", function () { zet(s.stuks - 1); });
      if (splus) splus.addEventListener("click", function () { zet(s.stuks + 1); });
      if (si) {
        si.addEventListener("input", function () { var w = num(si.value, NaN); if (Number.isFinite(w) && w >= 1) zet(w); });
        si.addEventListener("blur", function () { si.value = stuks(); });
      }
    })();

    /* ---------- in winkelwagen ---------- */
    var knopEl = root.querySelector("[data-vkm-bestel]");
    var foutEl = root.querySelector("[data-vkm-fout]");
    function toonFout(tekst) {
      if (!foutEl) return;
      foutEl.textContent = tekst;
      foutEl.hidden = !tekst;
    }

    if (knopEl) {
      knopEl.addEventListener("click", function () {
        var variantId = parseInt(cfg.variantId, 10);
        if (!variantId) {
          toonFout("De configurator is nog niet gekoppeld aan het maatwerk-product. Vul het variant-ID in bij de sectie-instellingen.");
          return;
        }
        var teGroot = kleedTeGroot();
        if (teGroot) { toonFout(teGroot); return; }
        var b = bereken();
        var k = kleuren[s.kleur] || { titel: "" };
        var v = vorm(), g = groep(), bb = randbreedte();
        var rk = randkleuren[s.randkleur] || { naam: "", nr: "" };
        var tv = trapvormen[s.trapvorm] || { naam: "", b: 0, d: 0 };

        var props = { "Kleur": k.titel };
        if (s.modus === "meter") {
          props["Uitvoering"] = "Per strekkende meter";
          props["Rolbreedte"] = getal(s.rolbreedte / 100) + " meter";
          props["Aantal meters"] = getal(meters()) + " m";
          props["Aantal"] = stuks() + (stuks() === 1 ? " stuk" : " stuks");
        } else if (s.modus === "trap") {
          props["Uitvoering"] = "Trapmatten op maat";
          props["Vorm"] = tv.naam + " " + tv.b + " × " + tv.d + " cm";
          props["Aantal matten"] = treden() + " stuks";
          props["Afwerkkleur"] = rk.naam + (rk.nr ? " (" + rk.nr + ")" : "");
        } else {
          props["Uitvoering"] = "Vloerkleed op maat";
          props["Vorm"] = vormNaamMaat(v);
          props["Afmeting"] = b.snij;
          props["Randafwerking"] = (g ? g.naam : "") + (bb && bb.sub ? ", " + bb.sub : "");
          props["Afwerkkleur"] = (cfg.toonRandkleur !== false)
            ? rk.naam + (rk.nr ? " (" + rk.nr + ")" : "")
            : "Bijpassend gematched";
          props["Anti-slip"] = ((g && g.antislipInbegrepen) || s.antislip) ? "ja" : "nee";
          props["Aantal"] = stuks() + (stuks() === 1 ? " kleed" : " kleden");
        }
        // De regel hangt aan een hulpvariant die "Maatwerk vloerkleed (niet los
        // bestellen)" heet. Zonder eigen naam, kleur, link en beeld is dat wat de
        // klant in zijn winkelwagen ziet staan. Kleur is zichtbaar (hoort ook op de
        // pakbon); titel, link en beeld zijn intern en sturen alleen de weergave.
        props["Kleur"] = k.titel || "";
        props["_titel"] = cfg.productTitel || "";
        props["_url"] = cfg.productHandle ? "/products/" + cfg.productHandle : "";
        props["_beeld"] = k.beeld || k.beeldGroot || "";
        props["_prijs"] = b.totaal.toFixed(2);
        props["_oppervlakte_m2"] = b.opp.toFixed(3);
        props["_randlengte_m"] = b.omtrek.toFixed(3);
        props["_eenheden"] = String(b.eenheden);   // per stuk; de regel heeft stuks() x zoveel
        // Uniek per toevoeging. Anders voegt Shopify een tweede, gelijk kleed samen met de eerste
        // regel: het aantal verdubbelt dan wel, maar "Aantal" in de eigenschappen niet.
        props["_regel"] = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        props["_toon_als_aantal"] = "1";
        if (s.modus !== "trap" && window.VMRuimte && window.VMRuimte.hadImpressie && window.VMRuimte.hadImpressie(cfg.productHandle)) props["_fotovoorbeeld"] = "1";
        props["_configuratie"] = JSON.stringify({
          modus: s.modus, vorm: s.vorm, lengte: s.lengte, breedte: s.breedte,
          diameter: s.diameter, rolbreedte: s.rolbreedte,
          groep: s.groep, randbreedte: s.randbreedte,
          randkleur: rk.naam, kleurVariant: k.id || null,
          antislip: ((g && g.antislipInbegrepen) || s.antislip),
          meters: meters(), treden: treden(), trapvorm: tv.naam,
          // Nodig om de regel vanuit de winkelwagen weer exact op te bouwen (zie herstel()).
          radius: heeftRadius(v) ? Math.round(hoekradius(v)) : null,
          randkleurNr: s.randkleur, trapvormNr: s.trapvorm, stuks: stuks()
        });

        var oudeTekst = knopEl.textContent;
        knopEl.disabled = true;
        knopEl.textContent = "Bezig…";
        toonFout("");

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity: b.eenheden * stuks(), properties: props }] })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || "Toevoegen lukte niet."); });
            return r.json();
          })
          .then(function (res) {
            // Bewerken vanuit de winkelwagen: de nieuwe regel staat erin, nu de oude eruit.
            // Eerst toevoegen en dan pas weghalen, zodat een mislukte toevoeging het kleed niet kost.
            if (!bewerkSleutel) return;
            var nieuw = res && res.items && res.items[0];
            var nieuweSleutel = nieuw ? nieuw.key : null;
            // Niets gewijzigd: Shopify voegt dan samen met de oude regel (zelfde sleutel) en
            // telt de aantallen op. Dan alleen het aantal terugzetten, anders verdwijnt het kleed.
            var wijzig = nieuweSleutel === bewerkSleutel
              ? { id: bewerkSleutel, quantity: b.eenheden * stuks() }
              : { id: bewerkSleutel, quantity: 0 };
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", "Accept": "application/json" },
              body: JSON.stringify(wijzig)
            })
              .catch(function () { /* oude regel al weg (ander tabblad): de nieuwe staat er, dat is genoeg */ })
              .then(function () { if (nieuweSleutel) bewerk(nieuweSleutel); });
          })
          .then(function () { return fetch("/cart.js", { headers: { "Accept": "application/json" } }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            /* de header-teller telt normaal het aantal stuks; bij dit product is dat
               het bedrag, dus tellen we kleden (quantity / _eenheden), zoals vm-cart-aantal */
            var telEl = document.querySelector("[data-header-cart-count]");
            if (telEl) {
              var zichtbaar = (cart.items || []).reduce(function (n, it) {
                var p = it.properties || {}, e = parseInt(p._eenheden, 10);
                return n + (p._toon_als_aantal ? (e > 0 ? Math.max(1, Math.floor(it.quantity / e)) : 1) : it.quantity);
              }, 0);
              telEl.setAttribute("data-header-cart-count", zichtbaar);
              telEl.classList.add("visible");
            }
            knopEl.textContent = bewerkSleutel ? "Bijgewerkt ✓" : "Toegevoegd ✓";
            setTimeout(function () { knopEl.textContent = oudeTekst; knopEl.disabled = false; }, 2200);
          })
          .catch(function (e) {
            knopEl.textContent = oudeTekst;
            knopEl.disabled = false;
            toonFout(e && e.message ? e.message : "Toevoegen lukte niet. Probeer het opnieuw of bel ons even.");
          });
      });
    }

    /* ---------- terug vanuit de winkelwagen ----------
       De winkelwagen linkt een maatwerkregel naar /products/<handle>?vkm_regel=<regelsleutel>.
       Dan halen we die regel op en zetten we alle keuzes uit `_configuratie` terug, zodat de
       klant zijn kleed weer ziet zoals hij het in de winkelwagen legde. De knop vervangt dan die
       regel in plaats van er een tweede kleed naast te leggen. */
    var bewerkSleutel = null;
    function bewerk(sleutel) {
      bewerkSleutel = sleutel;
      if (knopEl) knopEl.textContent = "Winkelwagen bijwerken";
      // Na het bijwerken heeft de regel een nieuwe sleutel; zo werkt herladen ook daarna nog.
      try {
        var u = new URL(window.location.href);
        u.searchParams.set("vkm_regel", sleutel);
        window.history.replaceState(window.history.state, "", u.toString());
      } catch (e) { /* oude browser: alleen herladen begint dan blanco */ }
    }
    function herstel(c) {
      if (MODI.some(function (o) { return o.id === c.modus; })) s.modus = c.modus;
      if (c.kleurVariant != null) {
        kleuren.forEach(function (k, i) { if (String(k.id) === String(c.kleurVariant)) s.kleur = i; });
      }
      if (VORMEN.some(function (o) { return o.id === c.vorm; })) s.vorm = c.vorm;
      var v = vorm();
      if (c.radius != null && heeftRadius(v)) s.radius[v.id] = Math.max(0, num(c.radius, s.radius[v.id]));
      // Vaste vormen hebben een vaste verhouding: één maat legt de andere vast.
      if (v.vrij) {
        zetVormMaat("breedte", num(c.breedte, s.breedte));
        zetVormMaat("lengte", num(c.lengte, s.lengte));
      } else if (v.invoer === "diameter") {
        zetVormMaat("diameter", num(c.diameter, s.diameter));
      } else {
        zetVormMaat("breedte", num(c.breedte, s.breedte));
        // De opgeslagen maten zijn al afgerond op 5 cm. Niet opnieuw vanuit de breedte schalen:
        // dan loopt de lengte nog eens op (ellips 300 x 400 werd 300 x 410, met toeslag; 19-10).
        var hb = num(c.breedte, NaN), hl = num(c.lengte, NaN);
        if (Number.isFinite(hb) && Number.isFinite(hl)) {
          s.breedte = op5(hb); s.lengte = op5(hl); s.diameter = s.breedte;
          zetInvoer("breedte", s.breedte); zetInvoer("lengte", s.lengte);
        }
      }
      if (c.rolbreedte) s.rolbreedte = num(c.rolbreedte, s.rolbreedte);
      if (groepen.some(function (o) { return o.sleutel === c.groep; })) {
        s.groep = c.groep;
        var g = groep();
        var heeft = g.breedtes.some(function (bb) { return bb.id === c.randbreedte; });
        s.randbreedte = heeft ? c.randbreedte : (g.breedtes[0] ? g.breedtes[0].id : null);
      }
      // Volgnummer eerst (staat sinds 15-10 in de configuratie), anders op naam.
      if (randkleuren[c.randkleurNr] && randkleuren[c.randkleurNr].naam === c.randkleur) s.randkleur = c.randkleurNr;
      else randkleuren.forEach(function (k, i) { if (k.naam === c.randkleur) s.randkleur = i; });
      if (trapvormen[c.trapvormNr] && trapvormen[c.trapvormNr].naam === c.trapvorm) s.trapvorm = c.trapvormNr;
      else trapvormen.forEach(function (t, i) { if (t.naam === c.trapvorm) s.trapvorm = i; });
      // Een afwerking met anti-slip inbegrepen slaat "ja" op. Dat niet als eigen keuze
      // overnemen, anders betaalt de klant ervoor zodra hij een andere afwerking kiest.
      var ag = groep();
      s.antislip = !!c.antislip && !(ag && ag.antislipInbegrepen);
      if (c.meters) { s.meters = num(c.meters, s.meters); zetInvoer("meters", s.meters); }
      if (c.treden) { s.treden = num(c.treden, s.treden); zetInvoer("treden", s.treden); }
      s.stuks = Math.max(1, Math.round(num(c.stuks, 1)));
    }
    function laadUitWinkelwagen() {
      var sleutel = null;
      try { sleutel = new URLSearchParams(window.location.search).get("vkm_regel"); } catch (e) { return; }
      if (!sleutel || !window.fetch) return;
      fetch("/cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (w) {
          var regel = w && (w.items || []).filter(function (it) { return it.key === sleutel; })[0];
          var p = regel && regel.properties;
          if (!p || !p._configuratie) return;   // regel al weg: gewoon blanco beginnen
          if (cfg.productHandle && p._url && p._url !== "/products/" + cfg.productHandle) return;
          var c;
          try { c = JSON.parse(p._configuratie); } catch (e) { return; }
          herstel(c);
          bewerk(sleutel);
          teken();
          meldKleur();
          // De stap-voor-stap-laag in de sectie verbergt anders alles na stap 1: alles is al gekozen.
          root.setAttribute("data-vkm-hersteld", "1");
          try { root.dispatchEvent(new CustomEvent("vkm:hersteld")); } catch (e) { /* oude browser: laag blijft bij stap 1 */ }
        })
        .catch(function () { /* zonder winkelwagen: blanco configurator, zoals altijd */ });
    }

    zetVormMaat("lengte", s.lengte);
    // Kleedje in de samenvatting: CSS rekt het vlak op tot de hoogte van de tabel, hier
    // wordt het even breed (vierkant). CSS-aspect-ratio kan dat niet bij een uitgerekt flex-item.
    var miniVak = root.querySelector("[data-vkm-mini]");
    if (miniVak && window.ResizeObserver) {
      new ResizeObserver(function () {
        var h = miniVak.offsetHeight;
        if (h && Math.abs(miniVak.offsetWidth - h) > 1) miniVak.style.width = h + "px";
      }).observe(miniVak);
    }
    if (window.VMRuimte) {
      ruimte = window.VMRuimte.mount(root.querySelector("[data-vkm-ruimte]"), {
        getChoice: ruimteKeuze,
        generate: cfg.ruimteEndpoint ? window.VMRuimte.generator(cfg.ruimteEndpoint) : null
      });
      var stopRuimte = function (event) {
        if (event.target === root || event.target.contains(root)) {
          if (ruimte) ruimte.destroy();
          document.removeEventListener("shopify:section:unload", stopRuimte);
        }
      };
      document.addEventListener("shopify:section:unload", stopRuimte);
    }
    teken();
    laadUitWinkelwagen();
    // De staalkaart (sections/vm-staal.liquid) kan eerder geladen zijn dan deze configurator:
    // meld de startkleur nu, en nog een keer zodra de pagina klaar is.
    meldKleur();
    if (document.readyState !== "complete") window.addEventListener("load", meldKleur);

    /* De koptekst van het thema klapt in tijdens het scrollen. De tekening moet daar
       netjes onder blijven hangen, dus meten we de werkelijke hoogte in plaats van
       een vaste afstand aan te houden. */
    var laatste = -1, gepland = false;
    function meetHeader() {
      gepland = false;
      var onder = 0;
      var kandidaten = document.querySelectorAll("header, .site-header, .header, [id*='header'], [class*='header']");
      for (var i = 0; i < kandidaten.length; i++) {
        var el = kandidaten[i];
        var cs = window.getComputedStyle(el);
        if (cs.position !== "fixed" && cs.position !== "sticky") continue;
        if (cs.visibility === "hidden" || cs.display === "none") continue;
        var r = el.getBoundingClientRect();
        if (r.height < 8 || r.height > 320) continue;
        if (r.top > 4) continue;              // hangt niet aan de bovenkant
        if (r.bottom > onder) onder = r.bottom;
      }
      var waarde = Math.round(Math.max(12, onder + 14));
      if (waarde !== laatste) {
        laatste = waarde;
        root.style.setProperty("--vkm-sticky", waarde + "px");
      }
    }
    function plan() {
      if (gepland) return;
      gepland = true;
      window.requestAnimationFrame(meetHeader);
    }
    meetHeader();
    window.addEventListener("scroll", plan, { passive: true });
    window.addEventListener("resize", plan);
    setTimeout(meetHeader, 600);
  }

  function init() {
    document.querySelectorAll("[data-vkm]").forEach(function (el) {
      if (el.getAttribute("data-vkm-gestart")) return;
      el.setAttribute("data-vkm-gestart", "1");
      start(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
